const es = {
  // ── Menu / Sidebar ───────────────────────────────────────
  "menu.overview": "Panel General",
  "menu.conversations": "Conversaciones",
  "menu.statistics": "Estadísticas",
  "menu.analytics": "Analíticas",
  "menu.clicks": "Clicks",
  "menu.adPerformance": "Rendimiento Ads",
  "menu.conversions": "Conversiones",
  "menu.crm": "CRM",
  "menu.crmCustomers": "Clientes",
  "menu.crmSales": "Ventas",
  "menu.catalog": "Catálogo",
  "menu.families": "Familias",
  "menu.usosGrupos": "Usos y Grupos",
  "menu.inventory": "Inventario",
  "menu.consumo": "Consumo",
  "menu.mapa": "Mapa",
  "mapa.title": "Mapa de México",
  "mapa.subtitle": "Distribución por estado. Pasa el cursor para ver el detalle.",
  "mapa.ml": "ML",
  "mapa.ventas": "Ventas",
  "mapa.conversations": "Conversaciones",
  "mapa.clicks": "Clicks",
  "mapa.p7": "7 días",
  "mapa.p30": "30 días",
  "mapa.p90": "90 días",
  "mapa.pall": "Todo",
  "mapa.hint": "Color más intenso = mayor volumen. Próximamente: acercar para ver municipios.",
  "menu.payment": "Pago",
  "consumo.title": "Consumo",
  "consumo.subtitle": "Conversaciones del mes {{month}}",
  "consumo.plan": "Plan",
  "consumo.perMonth": "{{n}} convos/mes",
  "consumo.today": "Hoy",
  "consumo.thisMonth": "Este mes",
  "consumo.remaining": "Restantes",
  "consumo.overage": "Excedente",
  "consumo.rateTBD": "tarifa por definir",
  "consumo.byDay": "Conversaciones por día",
  "payment.due": "💳 Tu pago mensual de {{price}} {{currency}} vence el día {{day}}.",
  "payment.overdue": "⚠️ Pago vencido: tu plan de {{price}} {{currency}} debía pagarse antes del día {{day}}. Regulariza para continuar sin interrupciones.",
  "menu.pos": "Puntos de Venta",
  "menu.campaigns": "Campañas",
  "menu.campAdmin": "Administración",
  "menu.campAnalysis": "Análisis",
  "menu.campStrategy": "Estrategia",
  "menu.campAgent": "Agente",
  "menu.campTools": "Herramientas",
  "menu.campaignsSub": "Campañas",
  "menu.adSets": "Ad Sets",
  "menu.ads": "Anuncios",
  "menu.desempeno": "Desempeño",
  "menu.segmentacion": "Segmentación",
  "menu.spendOptimization": "Optimización",
  "menu.flujos": "Estructura de flujos",
  "menu.convoFlows": "Flujos",
  "menu.forecast": "Pronóstico (Clics)",
  "menu.simulador": "Sandbox",
  "menu.intelligence": "Inteligencia Artificial",
  "menu.mlImport": "Importar Órdenes",
  "menu.trackedLinks": "Links de seguimiento",
  "menu.flowPrompts": "Prompts de Flujos",
  "menu.users": "Usuarios",
  "menu.usersSub": "Usuarios",
  "menu.roles": "Roles",
  "menu.profiles": "Perfiles",
  "menu.mercadoLibre": "Mercado Libre",
  "menu.orders": "Pedidos",
  "menu.importer": "Importar a Inventario",
  "menu.bot": "Bot",
  "menu.intents": "Intents",
  "menu.aiUsage": "Costos IA",
  "menu.workflows": "Workflows (beta)",
  "menu.adWorkflow": "Flujo en anuncio",
  "menu.sandbox": "Sandbox",
  "menu.promos": "Promociones",
  "menu.playground": "Playground",
  "menu.playgroundML": "Mercado Libre",
  "menu.playgroundForecast": "Pronóstico de Ventas",
  "menu.playgroundSegments": "Segmentación",
  "menu.playgroundConversion": "Prob. Conversión",
  "menu.messagePerformance": "Rendimiento de Mensajes",
  "menu.gcFollowUp": "Seguimiento Ground Cover",
  "menu.playgroundSpend": "Optimización de Gasto",
  "menu.tickets": "Tickets",
  "menu.salesOverview": "Resumen de Ventas",
  "menu.notifications": "Notificaciones",
  "menu.crossSell": "Cross-Selling",
  "menu.companyInfo": "Información General",
  "menu.reportedConvos": "Convos reportadas",
  "menu.settings": "Configuración",
  "menu.specOps": "Spec Ops",
  "menu.killswitch": "Killswitch",
  "menu.nukeEm": "Nuke'em",
  "menu.liberado": "Liberado",
  "menu.banner": "Banner",
  "menu.fbCommentReply": "Comentarios FB",
  "menu.help": "Ayuda",

  // ── Common ───────────────────────────────────────────────
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.delete": "Eliminar",
  "common.edit": "Editar",
  "common.add": "Agregar",
  "common.create": "Crear",
  "common.close": "Cerrar",
  "common.search": "Buscar",
  "common.loading": "Cargando...",
  "common.actions": "Acciones",
  "common.name": "Nombre",
  "common.description": "Descripción",
  "common.status": "Estado",
  "common.type": "Tipo",
  "common.date": "Fecha",
  "common.active": "Activo",
  "common.inactive": "Inactivo",
  "common.yes": "Sí",
  "common.no": "No",
  "common.none": "Ninguno",
  "common.all": "Todos",
  "common.back": "Volver",
  "common.next": "Siguiente",
  "common.previous": "Anterior",
  "common.confirm": "Confirmar",
  "common.required": "Requerido",
  "common.optional": "Opcional",
  "common.noData": "No hay datos",
  "common.error": "Error",
  "common.success": "Éxito",
  "common.warning": "Advertencia",
  "common.copy": "Copiar",
  "common.copied": "Copiado",
  "common.import": "Importar",
  "common.export": "Exportar",
  "common.details": "Detalles",
  "common.select": "Seleccionar",
  "common.selectOption": "Seleccionar opción",
  "common.refresh": "Actualizar",
  "common.processing": "Procesando...",
  "common.saving": "Guardando...",
  "common.deleting": "Eliminando...",
  "common.noResults": "Sin resultados",
  "common.viewAll": "Ver todos",
  "common.enable": "Activar",
  "common.disable": "Desactivar",
  "common.enabled": "Activado",
  "common.disabled": "Desactivado",
  "common.price": "Precio",
  "common.total": "Total",
  "common.filter": "Filtrar",
  "common.clear": "Limpiar",
  "common.apply": "Aplicar",
  "common.download": "Descargar",
  "common.upload": "Subir",
  "common.preview": "Vista previa",
  "common.link": "Enlace",
  "common.image": "Imagen",
  "common.category": "Categoría",
  "common.subcategory": "Subcategoría",
  "common.family": "Familia",
  "common.subfamily": "Subfamilia",
  "common.product": "Producto",
  "common.products": "Productos",
  "common.campaign": "Campaña",
  "common.adSet": "Ad Set",
  "common.ad": "Anuncio",
  "common.user": "Usuario",
  "common.role": "Rol",
  "common.profile": "Perfil",
  "common.email": "Email",
  "common.password": "Contraseña",
  "common.permissions": "Permisos",
  "common.createdAt": "Fecha de creación",
  "common.updatedAt": "Última actualización",

  // ── App.js Header / Sidebar ──────────────────────────────
  "app.subtitle": "Monitorea tu chatbot en tiempo real",
  "app.live": "En Vivo",
  "app.logout": "Cerrar Sesión",
  "app.admin": "Administrador",
  "app.updateAvailable": "Hay una nueva versión del dashboard disponible.",
  "app.updateButton": "Actualizar",
  "app.loadingAuth": "Cargando...",

  // ── Simulation Mode ──────────────────────────────────────
  "simulation.title": "Modo Simulación:",
  "simulation.viewingAs": "Viendo como",
  "simulation.allPermissions": "Todos los permisos",
  "simulation.permissionsCount": "{{count}} permisos",
  "simulation.exit": "Salir",
  "simulation.selectRole": "Simular rol",
  "simulation.selectProfile": "Seleccionar perfil",
  "simulation.start": "Iniciar simulación",
  "simulation.stop": "Detener simulación",
  "simulation.viewing": "Vista de simulación",
  "simulation.realView": "Vista real",

  // ── Overview / Dashboard ─────────────────────────────────
  "overview.todayStats": "Estadísticas de Hoy",
  "overview.totalMessages": "Mensajes Totales",
  "overview.uniqueUsers": "Chats únicos",
  "overview.responseRate": "Tasa de Respuesta",
  "overview.unanswered": "Sin Responder",
  "overview.activeCampaigns": "Campañas Activas",
  "overview.topRegion": "Región más activa",
  "overview.conversations": "conversaciones",
  "overview.activitySummary": "Resumen de Actividad (Últimas 12 horas)",
  "overview.answered": "Respondidos",
  "overview.received": "Recibidos",
  "overview.allMessages": "Todos los Mensajes",
  "overview.usersOnly": "Solo Usuarios",
  "overview.botOnly": "Solo Bot",
  "overview.recentConversations": "Conversaciones Recientes - Últimas 10",
  "overview.loadingMessages": "Cargando mensajes...",
  "overview.dateTime": "Fecha y Hora",
  "overview.userId": "ID de Usuario",
  "overview.message": "Mensaje",
  "overview.conversationDetail": "Detalle de Conversacion",
  "overview.bot": "Bot",
  "overview.userLabel": "Usuario",
  "overview.noMessages": "No hay mensajes",

  // ── Analytics ────────────────────────────────────────────
  "analytics.dailyMessages": "Mensajes del día",
  "analytics.activeCampaigns": "Campañas activas",
  "analytics.sales": "Ventas",
  "analytics.mostClickedAd": "Anuncio con más clics",
  "analytics.clicks": "clics",
  "analytics.ctr": "Tasa de clics (CTR)",
  "analytics.bestConversionRate": "Mejor tasa de conversión",
  "analytics.salesCount": "ventas",
  "analytics.bestSellingProduct": "Producto más vendido",

  // ── Delete Confirmations ─────────────────────────────────
  "delete.title": "Confirmar Eliminación",
  "delete.cannotUndo": "Esta acción no se puede deshacer",
  "delete.confirmGeneric": "¿Estás seguro de que deseas eliminar \"{{name}}\"?",
  "delete.confirmProduct": "¿Estás seguro de que deseas eliminar {{name}}?",
  "delete.confirmCampaign": "¿Estás seguro de que deseas eliminar la campaña {{name}}?",
  "delete.confirmItem": "¿Estás seguro de que deseas eliminar {{name}}?",
  "delete.deleteProduct": "Eliminar Producto",
  "delete.deleteCampaign": "Eliminar Campaña",
  "delete.deleteAdSet": "Eliminar Ad Set",
  "delete.deleteAd": "Eliminar Anuncio",
  "delete.deleteCampaignProduct": "Eliminar Producto de Campaña",
  "delete.deleteProductFamily": "Eliminar Familia de Productos",
  "delete.deleteCatalogEntry": "Eliminar Entrada del Catálogo",
  "delete.confirmProductFamily": "¿Estás seguro de que deseas eliminar {{name}}? Esto también eliminará todos sus hijos.",
  "delete.confirmCatalogEntry": "¿Estás seguro de que deseas eliminar la entrada {{name}} del catálogo maestro?",
  "delete.confirmCampaignProduct": "¿Estás seguro de que deseas eliminar el producto {{name}}?",
  "delete.cascadeCampaign": " Esto también eliminará todos los ad sets y anuncios asociados.",
  "delete.cascadeAdSet": " Esto también eliminará todos los anuncios asociados.",
  "delete.thisElement": "este elemento",
  "delete.confirmDelete": "¿Estás seguro de que deseas eliminar",
  "delete.campaignLabel": "Campaña",
  "delete.adSetLabel": "Ad Set",
  "delete.adLabel": "Anuncio",
  "delete.cascadeChildren": "Esto también eliminará todos sus hijos.",

  // ── Alert messages (from App.js handlers) ────────────────
  "alert.errorDeleteProduct": "Error al eliminar el producto",
  "alert.errorSaveProduct": "Error al guardar el producto",
  "alert.errorDeleteCampaign": "Error al eliminar la campaña",
  "alert.savedSuccess": "¡Guardado exitosamente! ad.summary: {{summary}}",
  "alert.errorSaveAdSet": "Error al guardar el conjunto de anuncios: ",
  "alert.errorDeleteAdSet": "Error al eliminar el conjunto de anuncios",
  "alert.errorSaveAd": "Error al guardar el anuncio: ",
  "alert.errorDeleteAd": "Error al eliminar el anuncio",
  "alert.errorDeleteCampaignProduct": "Error al eliminar el producto de campaña",
  "alert.errorSaveCampaignProduct": "Error al guardar el producto de campaña",
  "alert.errorDeleteCatalog": "Error al eliminar la entrada del catálogo maestro",
  "alert.errorSaveCatalog": "Error al guardar la entrada del catálogo maestro",
  "alert.errorDeleteUso": "Error al eliminar el uso",
  "alert.errorSaveUso": "Error al guardar el uso",
  "alert.errorDeleteGrupo": "Error al eliminar el grupo",
  "alert.errorSaveGrupo": "Error al guardar el grupo",
  "alert.errorDeletePOS": "Error al eliminar el punto de venta",
  "alert.errorSavePOS": "Error al guardar el punto de venta",
  "alert.errorDeleteProductFamily": "Error: No se puede eliminar el producto porque el ID no es válido",
  "alert.errorCopyProduct": "Error al copiar producto",
  "alert.confirmDeleteUso": "¿Estás seguro de eliminar el uso \"{{name}}\"?\n\nEsta acción no se puede deshacer.",
  "alert.confirmDeleteGrupo": "¿Estás seguro de eliminar el grupo \"{{name}}\"?\n\nEsta acción no se puede deshacer.",
  "alert.confirmDeletePOS": "¿Estás seguro de eliminar el punto de venta \"{{name}}\"?\n\nEsta acción no se puede deshacer.",
  "alert.takeoverSuccess": "Tomaste el control · el bot ya no responderá esta conversación.",
  "alert.releaseSuccess": "Conversación liberada · el bot puede responder de nuevo.",

  // ── Login ────────────────────────────────────────────────
  "login.title": "Hanlob Bot",
  "login.subtitle": "Dashboard de Administración",
  "login.username": "Usuario",
  "login.password": "Contraseña",
  "login.usernamePlaceholder": "Ingresa tu usuario",
  "login.passwordPlaceholder": "Ingresa tu contraseña",
  "login.submit": "Iniciar Sesión",
  "login.loading": "Iniciando sesión...",
  "login.forgotPassword": "¿Olvidaste tu contraseña?",
  "login.defaultCredentials": "Credenciales por defecto:",
  "login.errorRequired": "Por favor ingresa usuario y contraseña",
  "login.errorGeneric": "Error al iniciar sesión",
  "login.welcome": "¡Bienvenido!",

  // ── Forgot Password ──────────────────────────────────────
  "forgot.title": "Recuperar contraseña",
  "forgot.subtitle": "Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.",
  "forgot.emailLabel": "Correo electrónico",
  "forgot.emailPlaceholder": "tu@correo.com",
  "forgot.submit": "Enviar enlace de recuperación",
  "forgot.sending": "Enviando...",
  "forgot.backToLogin": "Volver al inicio de sesión",
  "forgot.errorRequired": "Por favor ingresa tu correo electrónico",
  "forgot.successToast": "Revisa tu correo electrónico",
  "forgot.checkEmail": "Revisa tu correo",
  "forgot.checkEmailSubtitle": "Si existe una cuenta con ese correo, recibirás un enlace para restablecer tu contraseña.",
  "forgot.sentTo": "Te enviamos un correo a",
  "forgot.linkExpires": "El enlace expirará en 1 hora. Si no lo ves, revisa tu carpeta de spam.",

  // ── Reset Password ───────────────────────────────────────
  "reset.title": "Nueva contraseña",
  "reset.greeting": "Hola {{name}}, ingresa tu nueva contraseña.",
  "reset.newPassword": "Nueva contraseña",
  "reset.confirmPassword": "Confirmar contraseña",
  "reset.minChars": "Mínimo 6 caracteres",
  "reset.repeatPassword": "Repite tu contraseña",
  "reset.submit": "Restablecer contraseña",
  "reset.updating": "Actualizando...",
  "reset.verifying": "Verificando enlace...",
  "reset.invalidLink": "Enlace inválido",
  "reset.invalidSubtitle": "Este enlace de recuperación es inválido o ha expirado.",
  "reset.linkExpired": "Los enlaces de recuperación expiran después de 1 hora por seguridad.",
  "reset.requestNew": "Solicitar nuevo enlace",
  "reset.successTitle": "Contraseña actualizada",
  "reset.successSubtitle": "Tu contraseña ha sido restablecida correctamente.",
  "reset.goToLogin": "Iniciar sesión",
  "reset.errorRequired": "Por favor completa todos los campos",
  "reset.errorMismatch": "Las contraseñas no coinciden",
  "reset.errorMinLength": "La contraseña debe tener al menos 6 caracteres",
  "reset.successToast": "Contraseña actualizada correctamente",
  "reset.errorGeneric": "Error al restablecer la contraseña",

  // ── Settings ─────────────────────────────────────────────
  "settings.title": "Configuración",
  "settings.userInfo": "Información de Usuario",
  "settings.usernameLabel": "Usuario:",
  "settings.fullName": "Nombre completo:",
  "settings.emailLabel": "Email:",
  "settings.roleLabel": "Rol:",
  "settings.profileLabel": "Perfil:",
  "settings.pushNotifications": "Notificaciones Push",
  "settings.pushNotSupported": "Tu navegador no soporta notificaciones push.",
  "settings.pushDescription": "Recibe alertas cuando un cliente necesite ayuda humana, incluso cuando no estés en el dashboard.",
  "settings.pushEnabled": "Notificaciones activadas",
  "settings.pushDisabled": "Notificaciones desactivadas",
  "settings.pushDenied": "Permiso de notificaciones denegado",
  "settings.pushErrorEnable": "Error al activar notificaciones",
  "settings.pushErrorDisable": "Error al desactivar notificaciones",
  "settings.changePassword": "Cambiar Contraseña",
  "settings.currentPassword": "Contraseña Actual",
  "settings.newPassword": "Nueva Contraseña",
  "settings.confirmNewPassword": "Confirmar Nueva Contraseña",
  "settings.currentPasswordPlaceholder": "Ingresa tu contraseña actual",
  "settings.newPasswordPlaceholder": "Mínimo 6 caracteres",
  "settings.confirmPasswordPlaceholder": "Confirma tu nueva contraseña",
  "settings.changingPassword": "Cambiando contraseña...",
  "settings.submitChangePassword": "Cambiar Contraseña",
  "settings.errorAllRequired": "Todos los campos son requeridos",
  "settings.errorMinLength": "La nueva contraseña debe tener al menos 6 caracteres",
  "settings.errorMismatch": "Las contraseñas no coinciden",
  "settings.passwordChanged": "Contraseña cambiada exitosamente",
  "settings.errorChangePassword": "Error al cambiar la contraseña",
  "settings.language": "Idioma",
  "settings.languageDescription": "Selecciona el idioma del dashboard.",

  // ── AuthContext ──────────────────────────────────────────
  "auth.serverError": "Error al conectar con el servidor",

  // ── Messages / Conversations ─────────────────────────────
  "messages.title": "Conversaciones",
  "messages.search": "Buscar por PSID o mensaje...",
  "messages.noConversations": "No hay conversaciones",
  "messages.loadMore": "Cargar más",
  "messages.typeMessage": "Escribe un mensaje...",
  "messages.send": "Enviar",
  "messages.takeover": "Tomar control",
  "messages.release": "Liberar",
  "messages.humanControlled": "Control humano",
  "messages.botControlled": "Control del bot",
  "messages.today": "Hoy",
  "messages.yesterday": "Ayer",
  "messages.noMessages": "No hay mensajes en esta conversación",
  "messages.handoverActive": "Atención humana activa",
  "messages.handoverBy": "Por: {{agent}}",
  "messages.handoverSince": "Desde: {{date}}",
  "messages.returnToBot": "Devolver al bot",
  "messages.takeControl": "Tomar control",
  "messages.location": "Ubicación",
  "messages.region": "Región",
  "messages.selectConversation": "Selecciona una conversación",
  "messages.selectConversationDesc": "Elige una conversación de la lista para ver los mensajes",
  "messages.priority.urgent": "Urgente",
  "messages.priority.high": "Alta",
  "messages.priority.normal": "Normal",
  "messages.handoff": "Handoff",
  "messages.handoffReason": "Razón",
  "messages.conversationWith": "Conversación con",
  "messages.messageCount": "{{count}} mensajes",
  "messages.lastMessage": "Último mensaje",

  // ── Products ─────────────────────────────────────────────
  "products.title": "Productos",
  "products.addProduct": "Agregar Producto",
  "products.editProduct": "Editar Producto",
  "products.newProduct": "Nuevo Producto",
  "products.noProducts": "No hay productos",
  "products.searchPlaceholder": "Buscar productos...",
  "products.productName": "Nombre del Producto",
  "products.sku": "SKU",
  "products.price": "Precio",
  "products.stock": "Stock",
  "products.unit": "Unidad",

  // ── Product Families ─────────────────────────────────────
  "families.title": "Familias de Productos",
  "families.addFamily": "Agregar Familia",
  "families.editFamily": "Editar Familia",
  "families.newFamily": "Nueva Familia",
  "families.addChild": "Agregar hijo",
  "families.copyProduct": "Copiar producto",
  "families.importProducts": "Importar productos",
  "families.viewDetails": "Ver detalles",
  "families.noFamilies": "No hay familias de productos",
  "families.sellable": "Vendible",
  "families.notSellable": "No vendible",
  "families.parentFamily": "Familia padre",
  "families.noParent": "Sin padre (raíz)",
  "families.children": "hijos",
  "families.specifications": "Especificaciones",
  "families.materials": "Materiales",
  "families.uses": "Usos",
  "families.appliances": "Aplicaciones",
  "families.onlineStoreLinks": "Enlaces de tienda en línea",
  "families.addLink": "Agregar enlace",
  "families.storeName": "Nombre de tienda",
  "families.storeUrl": "URL de tienda",
  "families.productDetails": "Detalles del Producto",
  "families.breadcrumb": "Ruta",
  "families.showAll": "Mostrar todo",
  "families.collapseAll": "Colapsar todo",
  "families.expandAll": "Expandir todo",

  // ── Copy Product Modal ───────────────────────────────────
  "copyProduct.title": "Copiar Producto",
  "copyProduct.selectChildren": "Seleccionar hijos a copiar",
  "copyProduct.selectAll": "Seleccionar todos",
  "copyProduct.deselectAll": "Deseleccionar todos",
  "copyProduct.selectTarget": "Seleccionar destino",
  "copyProduct.targetParent": "Familia destino",
  "copyProduct.rootLevel": "Nivel raíz",
  "copyProduct.copy": "Copiar",
  "copyProduct.copying": "Copiando...",

  // ── Import Products Modal ────────────────────────────────
  "importProducts.title": "Importar Productos",
  "importProducts.target": "Importar a: {{name}}",
  "importProducts.selectFile": "Seleccionar archivo",
  "importProducts.dragDrop": "Arrastra un archivo aquí o haz clic para seleccionar",
  "importProducts.formats": "Formatos aceptados: CSV, Excel",
  "importProducts.importing": "Importando...",
  "importProducts.success": "Productos importados exitosamente",
  "importProducts.error": "Error al importar productos",

  // ── Product Details Modal ────────────────────────────────
  "productDetails.title": "Detalles del Producto",
  "productDetails.generalInfo": "Información General",
  "productDetails.specs": "Especificaciones",
  "productDetails.noSpecs": "Sin especificaciones",
  "productDetails.images": "Imágenes",
  "productDetails.noImages": "Sin imágenes",

  // ── Campaigns ────────────────────────────────────────────
  "campaigns.title": "Campañas",
  "campaigns.addCampaign": "Nueva Campaña",
  "campaigns.editCampaign": "Editar Campaña",
  "campaigns.noCampaigns": "No hay campañas",
  "campaigns.searchPlaceholder": "Buscar campañas...",
  "campaigns.active": "Activa",
  "campaigns.paused": "Pausada",
  "campaigns.scheduled": "Programada",
  "campaigns.draft": "Borrador",
  "campaigns.startDate": "Fecha de inicio",
  "campaigns.endDate": "Fecha de fin",
  "campaigns.budget": "Presupuesto",
  "campaigns.objective": "Objetivo",
  "campaigns.catalogInherited": "Catálogo heredado",
  "campaigns.ownCatalog": "Catálogo propio",

  // ── Campaign Modal ───────────────────────────────────────
  "campaignModal.title": "Campaña",
  "campaignModal.create": "Crear Campaña",
  "campaignModal.edit": "Editar Campaña",
  "campaignModal.name": "Nombre de la campaña",
  "campaignModal.namePlaceholder": "Ej: Campaña de Verano 2025",
  "campaignModal.objective": "Objetivo",
  "campaignModal.objectivePlaceholder": "Ej: Aumentar ventas en un 20%",
  "campaignModal.description": "Descripción",
  "campaignModal.descriptionPlaceholder": "Describe la campaña...",
  "campaignModal.startDate": "Fecha de inicio",
  "campaignModal.endDate": "Fecha de fin",
  "campaignModal.budget": "Presupuesto",
  "campaignModal.active": "Activa",
  "campaignModal.status": "Estado",
  "campaignModal.catalog": "Catálogo",
  "campaignModal.selectCatalog": "Seleccionar catálogo",
  "campaignModal.useParentCatalog": "Usar catálogo padre",
  "campaignModal.adSetsSection": "Ad Sets",
  "campaignModal.addAdSet": "Agregar Ad Set",
  "campaignModal.adsSection": "Anuncios",
  "campaignModal.addAd": "Agregar Anuncio",
  "campaignModal.targetAudience": "Audiencia objetivo",
  "campaignModal.targetAudiencePlaceholder": "Describe tu audiencia objetivo...",
  "campaignModal.trackingUrl": "URL de seguimiento",
  "campaignModal.general": "General",
  "campaignModal.schedule": "Programación",
  "campaignModal.noAdSets": "No hay ad sets",
  "campaignModal.noAds": "No hay anuncios",
  "campaignModal.summary": "Resumen",
  "campaignModal.summaryPlaceholder": "Resumen breve del anuncio...",
  "campaignModal.productFamilies": "Familias de productos",
  "campaignModal.selectFamilies": "Seleccionar familias",
  "campaignModal.inheritFromCampaign": "Heredar de campaña",
  "campaignModal.inheritFromAdSet": "Heredar de ad set",
  "campaignModal.ownSelection": "Selección propia",
  "campaignModal.fbCampaignId": "ID de Campaña de Facebook",
  "campaignModal.fbAdSetId": "ID de Ad Set de Facebook",
  "campaignModal.fbAdId": "ID de Anuncio de Facebook",

  // ── Campaign Tree View ───────────────────────────────────
  "campaignTree.title": "Campañas",
  "campaignTree.addCampaign": "Nueva Campaña",
  "campaignTree.noCampaigns": "No hay campañas",
  "campaignTree.searchPlaceholder": "Buscar...",
  "campaignTree.addAdSet": "Agregar Ad Set",
  "campaignTree.addAd": "Agregar Anuncio",
  "campaignTree.details": "Detalles",
  "campaignTree.expand": "Expandir",
  "campaignTree.collapse": "Colapsar",
  "campaignTree.expandAll": "Expandir todo",
  "campaignTree.collapseAll": "Colapsar todo",

  // ── Campaign Item Details Modal ──────────────────────────
  "campaignDetails.title": "Detalles",
  "campaignDetails.campaignInfo": "Información de Campaña",
  "campaignDetails.adSetInfo": "Información de Ad Set",
  "campaignDetails.adInfo": "Información de Anuncio",
  "campaignDetails.noDetails": "Sin detalles disponibles",

  // ── Ad Sets ──────────────────────────────────────────────
  "adSets.title": "Ad Sets",
  "adSets.addAdSet": "Nuevo Ad Set",
  "adSets.editAdSet": "Editar Ad Set",
  "adSets.noAdSets": "No hay ad sets",
  "adSets.searchPlaceholder": "Buscar ad sets...",
  "adSets.campaign": "Campaña",
  "adSets.selectCampaign": "Seleccionar campaña",
  "adSets.adsCount": "{{count}} anuncios",
  "adSets.name": "Nombre del Ad Set",
  "adSets.namePlaceholder": "Ej: Audiencia principal",

  // ── Ad Set Modal ─────────────────────────────────────────
  "adSetModal.title": "Ad Set",
  "adSetModal.create": "Crear Ad Set",
  "adSetModal.edit": "Editar Ad Set",
  "adSetModal.name": "Nombre",
  "adSetModal.namePlaceholder": "Nombre del ad set",
  "adSetModal.campaign": "Campaña",
  "adSetModal.selectCampaign": "Seleccionar campaña",
  "adSetModal.status": "Estado",
  "adSetModal.budget": "Presupuesto",
  "adSetModal.targeting": "Segmentación",
  "adSetModal.catalog": "Catálogo",

  // ── Ads ──────────────────────────────────────────────────
  "ads.title": "Anuncios",
  "ads.addAd": "Nuevo Anuncio",
  "ads.editAd": "Editar Anuncio",
  "ads.noAds": "No hay anuncios",
  "ads.searchPlaceholder": "Buscar anuncios...",
  "ads.adSet": "Ad Set",
  "ads.selectAdSet": "Seleccionar ad set",
  "ads.impressions": "Impresiones",
  "ads.clicks": "Clics",
  "ads.ctr": "CTR",
  "ads.conversions": "Conversiones",
  "ads.name": "Nombre del Anuncio",

  // ── Ad Modal ─────────────────────────────────────────────
  "adModal.title": "Anuncio",
  "adModal.create": "Crear Anuncio",
  "adModal.edit": "Editar Anuncio",
  "adModal.name": "Nombre",
  "adModal.namePlaceholder": "Nombre del anuncio",
  "adModal.adSet": "Ad Set",
  "adModal.selectAdSet": "Seleccionar ad set",
  "adModal.type": "Tipo de anuncio",
  "adModal.headline": "Título",
  "adModal.headlinePlaceholder": "Título del anuncio",
  "adModal.body": "Texto del anuncio",
  "adModal.bodyPlaceholder": "Escribe el texto del anuncio...",
  "adModal.callToAction": "Llamada a la acción",
  "adModal.ctaPlaceholder": "Ej: Comprar ahora",
  "adModal.imageUrl": "URL de imagen",
  "adModal.imageUrlPlaceholder": "https://...",
  "adModal.linkUrl": "URL de destino",
  "adModal.linkUrlPlaceholder": "https://...",
  "adModal.status": "Estado",
  "adModal.summary": "Resumen",
  "adModal.summaryPlaceholder": "Resumen breve del anuncio",
  "adModal.catalog": "Catálogo",
  "adModal.productFamilies": "Familias de productos",
  "adModal.selectFamilies": "Seleccionar familias",
  "adModal.fbAdId": "ID de Anuncio de Facebook",
  "adModal.fbAdIdPlaceholder": "ID del anuncio en Facebook",
  "adModal.trackingUrl": "URL de seguimiento",
  "adModal.clickUrl": "URL de clic",
  "adModal.clickUrlPlaceholder": "URL del enlace rastreable",

  // ── Campaign Products ────────────────────────────────────
  "campaignProducts.title": "Productos de Campaña",
  "campaignProducts.addProduct": "Agregar Producto",
  "campaignProducts.noProducts": "No hay productos de campaña",

  // ── Master Catalog ───────────────────────────────────────
  "masterCatalog.title": "Catálogo Maestro",
  "masterCatalog.addEntry": "Nueva Entrada",
  "masterCatalog.editEntry": "Editar Entrada",
  "masterCatalog.noEntries": "No hay entradas en el catálogo maestro",
  "masterCatalog.searchPlaceholder": "Buscar en catálogo maestro...",
  "masterCatalog.family": "Familia",
  "masterCatalog.subfamily": "Subfamilia",
  "masterCatalog.materials": "Materiales",
  "masterCatalog.generalUses": "Usos generales",
  "masterCatalog.generalSpecs": "Especificaciones generales",
  "masterCatalog.generalAppliances": "Aplicaciones generales",

  // ── Master Catalog Modal ─────────────────────────────────
  "masterCatalogModal.title": "Entrada del Catálogo Maestro",
  "masterCatalogModal.create": "Crear Entrada",
  "masterCatalogModal.edit": "Editar Entrada",
  "masterCatalogModal.selectFamily": "Seleccionar familia",
  "masterCatalogModal.subfamilyName": "Nombre de subfamilia",
  "masterCatalogModal.subfamilyPlaceholder": "Nombre de la subfamilia",
  "masterCatalogModal.materials": "Materiales",
  "masterCatalogModal.materialsPlaceholder": "Materiales usados...",
  "masterCatalogModal.generalUses": "Usos generales",
  "masterCatalogModal.generalUsesPlaceholder": "Usos generales del producto...",
  "masterCatalogModal.generalSpecs": "Especificaciones generales (JSON)",
  "masterCatalogModal.generalAppliances": "Aplicaciones generales",
  "masterCatalogModal.generalAppliancesPlaceholder": "Aplicaciones generales...",

  // ── Usos y Grupos ───────────────────────────────────────
  "usosGrupos.title": "Usos y Grupos",
  "usosGrupos.usosTab": "Usos",
  "usosGrupos.gruposTab": "Grupos",

  // ── Usos ─────────────────────────────────────────────────
  "usos.title": "Usos",
  "usos.addUso": "Nuevo Uso",
  "usos.editUso": "Editar Uso",
  "usos.noUsos": "No hay usos",
  "usos.name": "Nombre del uso",
  "usos.namePlaceholder": "Nombre del uso",
  "usos.description": "Descripción",
  "usos.descriptionPlaceholder": "Descripción del uso...",

  // ── Usos Modal ───────────────────────────────────────────
  "usosModal.title": "Uso",
  "usosModal.create": "Crear Uso",
  "usosModal.edit": "Editar Uso",

  // ── Grupos ───────────────────────────────────────────────
  "grupos.title": "Grupos",
  "grupos.addGrupo": "Nuevo Grupo",
  "grupos.editGrupo": "Editar Grupo",
  "grupos.noGrupos": "No hay grupos",
  "grupos.name": "Nombre del grupo",
  "grupos.namePlaceholder": "Nombre del grupo",
  "grupos.description": "Descripción",
  "grupos.descriptionPlaceholder": "Descripción del grupo...",

  // ── Grupos Modal ─────────────────────────────────────────
  "gruposModal.title": "Grupo",
  "gruposModal.create": "Crear Grupo",
  "gruposModal.edit": "Editar Grupo",

  // ── Puntos de Venta ──────────────────────────────────────
  "pos.title": "Puntos de Venta",
  "pos.addPOS": "Nuevo Punto de Venta",
  "pos.editPOS": "Editar Punto de Venta",
  "pos.noPOS": "No hay puntos de venta",
  "pos.searchPlaceholder": "Buscar puntos de venta...",
  "pos.name": "Nombre",
  "pos.address": "Dirección",
  "pos.city": "Ciudad",
  "pos.state": "Estado",
  "pos.phone": "Teléfono",
  "pos.schedule": "Horario",
  "pos.googleMapsUrl": "URL de Google Maps",
  "pos.namePlaceholder": "Nombre del punto de venta",
  "pos.addressPlaceholder": "Dirección completa",
  "pos.cityPlaceholder": "Ciudad",
  "pos.statePlaceholder": "Estado",
  "pos.phonePlaceholder": "Teléfono",
  "pos.schedulePlaceholder": "Ej: Lun-Vie 9:00-18:00",
  "pos.googleMapsPlaceholder": "URL de Google Maps",

  // ── Punto de Venta Modal ─────────────────────────────────
  "posModal.title": "Punto de Venta",
  "posModal.create": "Crear Punto de Venta",
  "posModal.edit": "Editar Punto de Venta",

  // ── Inventario ───────────────────────────────────────────
  "inventory.title": "Inventario",
  "inventory.searchPlaceholder": "Buscar en inventario...",
  "inventory.noItems": "No hay items en el inventario",
  "inventory.family": "Familia",
  "inventory.product": "Producto",
  "inventory.stock": "Stock",
  "inventory.minStock": "Stock mínimo",
  "inventory.maxStock": "Stock máximo",
  "inventory.lastUpdated": "Última actualización",
  "inventory.updateStock": "Actualizar stock",
  "inventory.lowStock": "Stock bajo",
  "inventory.outOfStock": "Sin stock",
  "inventory.inStock": "En stock",

  // ── Users ────────────────────────────────────────────────
  "users.title": "Usuarios",
  "users.addUser": "Nuevo Usuario",
  "users.editUser": "Editar Usuario",
  "users.noUsers": "No hay usuarios",
  "users.searchPlaceholder": "Buscar usuarios...",
  "users.username": "Usuario",
  "users.fullName": "Nombre completo",
  "users.email": "Email",
  "users.role": "Rol",
  "users.profile": "Perfil",
  "users.lastLogin": "Último acceso",
  "users.createdAt": "Creado",
  "users.deleteConfirm": "¿Estás seguro de eliminar al usuario \"{{name}}\"?",

  // ── User Modal ───────────────────────────────────────────
  "userModal.title": "Usuario",
  "userModal.create": "Crear Usuario",
  "userModal.edit": "Editar Usuario",
  "userModal.username": "Nombre de usuario",
  "userModal.usernamePlaceholder": "Nombre de usuario",
  "userModal.firstName": "Nombre",
  "userModal.firstNamePlaceholder": "Nombre",
  "userModal.lastName": "Apellido",
  "userModal.lastNamePlaceholder": "Apellido",
  "userModal.email": "Email",
  "userModal.emailPlaceholder": "email@ejemplo.com",
  "userModal.password": "Contraseña",
  "userModal.passwordPlaceholder": "Mínimo 6 caracteres",
  "userModal.passwordEditNote": "(Dejar vacío para no cambiar)",
  "userModal.role": "Rol",
  "userModal.selectRole": "Seleccionar rol",
  "userModal.profile": "Perfil",
  "userModal.selectProfile": "Seleccionar perfil",
  "userModal.permissions": "Permisos",

  // ── Roles ────────────────────────────────────────────────
  "roles.title": "Roles",
  "roles.addRole": "Nuevo Rol",
  "roles.editRole": "Editar Rol",
  "roles.noRoles": "No hay roles",
  "roles.searchPlaceholder": "Buscar roles...",
  "roles.name": "Nombre",
  "roles.label": "Etiqueta",
  "roles.usersCount": "Usuarios",
  "roles.permissions": "Permisos",
  "roles.deleteConfirm": "¿Estás seguro de eliminar el rol \"{{name}}\"?",

  // ── Role Modal ───────────────────────────────────────────
  "roleModal.title": "Rol",
  "roleModal.create": "Crear Rol",
  "roleModal.edit": "Editar Rol",
  "roleModal.name": "Nombre del rol",
  "roleModal.namePlaceholder": "Ej: super_admin",
  "roleModal.label": "Etiqueta",
  "roleModal.labelPlaceholder": "Ej: Super Administrador",
  "roleModal.permissions": "Permisos",
  "roleModal.selectAll": "Seleccionar todos",
  "roleModal.deselectAll": "Deseleccionar todos",

  // ── Profiles ─────────────────────────────────────────────
  "profiles.title": "Perfiles",
  "profiles.addProfile": "Nuevo Perfil",
  "profiles.editProfile": "Editar Perfil",
  "profiles.noProfiles": "No hay perfiles",
  "profiles.searchPlaceholder": "Buscar perfiles...",
  "profiles.name": "Nombre",
  "profiles.label": "Etiqueta",
  "profiles.role": "Rol",
  "profiles.deleteConfirm": "¿Estás seguro de eliminar el perfil \"{{name}}\"?",

  // ── Profile Modal ────────────────────────────────────────
  "profileModal.title": "Perfil",
  "profileModal.create": "Crear Perfil",
  "profileModal.edit": "Editar Perfil",
  "profileModal.name": "Nombre del perfil",
  "profileModal.namePlaceholder": "Ej: accounting",
  "profileModal.label": "Etiqueta",
  "profileModal.labelPlaceholder": "Ej: Contabilidad",
  "profileModal.role": "Rol al que pertenece",
  "profileModal.selectRole": "Seleccionar rol",

  // ── Click Logs ───────────────────────────────────────────
  "clickLogs.title": "Clicks",
  "clickLogs.noLogs": "No hay registros de clicks",
  "clickLogs.searchPlaceholder": "Buscar clicks...",
  "clickLogs.adName": "Anuncio",
  "clickLogs.productName": "Producto",
  "clickLogs.psid": "PSID",
  "clickLogs.timestamp": "Fecha",
  "clickLogs.converted": "Convertido",
  "clickLogs.notConverted": "No convertido",
  "clickLogs.conversionDate": "Fecha de conversión",
  "clickLogs.region": "Región",
  "clickLogs.all": "Todos",
  "clickLogs.convertedOnly": "Convertidos",
  "clickLogs.notConvertedOnly": "No convertidos",
  "clickLogs.totalClicks": "Total clicks",
  "clickLogs.totalConversions": "Total conversiones",
  "clickLogs.conversionRate": "Tasa de conversión",

  // ── Conversions ──────────────────────────────────────────
  "conversions.title": "Conversiones",
  "conversions.noConversions": "No hay conversiones",
  "conversions.searchPlaceholder": "Buscar conversiones...",
  "conversions.product": "Producto",
  "conversions.ad": "Anuncio",
  "conversions.date": "Fecha",
  "conversions.amount": "Monto",
  "conversions.status": "Estado",
  "conversions.total": "Total conversiones",
  "conversions.revenue": "Ingresos",

  // ── Intents ──────────────────────────────────────────────
  "intents.title": "Intents",
  "intents.addIntent": "Nuevo Intent",
  "intents.editIntent": "Editar Intent",
  "intents.noIntents": "No hay intents",
  "intents.searchPlaceholder": "Buscar intents...",
  "intents.name": "Nombre",
  "intents.category": "Categoría",
  "intents.patterns": "Patrones",
  "intents.responses": "Respuestas",
  "intents.priority": "Prioridad",
  "intents.addCategory": "Nueva Categoría",
  "intents.editCategory": "Editar Categoría",
  "intents.deleteConfirm": "¿Estás seguro de eliminar el intent \"{{name}}\"?",
  "intents.examples": "Ejemplos",
  "intents.addExample": "Agregar ejemplo",
  "intents.addResponse": "Agregar respuesta",
  "intents.addPattern": "Agregar patrón",
  "intents.noCategories": "No hay categorías",

  // ── Intent Modal ─────────────────────────────────────────
  "intentModal.title": "Intent",
  "intentModal.create": "Crear Intent",
  "intentModal.edit": "Editar Intent",
  "intentModal.name": "Nombre",
  "intentModal.namePlaceholder": "Nombre del intent",
  "intentModal.category": "Categoría",
  "intentModal.selectCategory": "Seleccionar categoría",
  "intentModal.patterns": "Patrones de detección",
  "intentModal.patternsPlaceholder": "Agregar patrón...",
  "intentModal.responses": "Respuestas",
  "intentModal.responsePlaceholder": "Agregar respuesta...",
  "intentModal.priority": "Prioridad",
  "intentModal.enabled": "Habilitado",
  "intentModal.description": "Descripción",
  "intentModal.descriptionPlaceholder": "Descripción del intent...",

  // ── Intent Category Modal ────────────────────────────────
  "intentCategoryModal.title": "Categoría de Intent",
  "intentCategoryModal.create": "Crear Categoría",
  "intentCategoryModal.edit": "Editar Categoría",
  "intentCategoryModal.name": "Nombre",
  "intentCategoryModal.namePlaceholder": "Nombre de la categoría",
  "intentCategoryModal.description": "Descripción",
  "intentCategoryModal.descriptionPlaceholder": "Descripción de la categoría...",

  // ── Flows ────────────────────────────────────────────────
  "flows.title": "Flows",
  "flows.addFlow": "Nuevo Flow",
  "flows.editFlow": "Editar Flow",
  "flows.noFlows": "No hay flows",
  "flows.searchPlaceholder": "Buscar flows...",
  "flows.name": "Nombre",
  "flows.trigger": "Trigger",
  "flows.steps": "Pasos",
  "flows.deleteConfirm": "¿Estás seguro de eliminar el flow \"{{name}}\"?",

  // ── Flow Modal ───────────────────────────────────────────
  "flowModal.title": "Flow",
  "flowModal.create": "Crear Flow",
  "flowModal.edit": "Editar Flow",
  "flowModal.name": "Nombre",
  "flowModal.namePlaceholder": "Nombre del flow",
  "flowModal.trigger": "Trigger",
  "flowModal.triggerPlaceholder": "Trigger del flow",
  "flowModal.addStep": "Agregar paso",
  "flowModal.stepType": "Tipo de paso",
  "flowModal.stepContent": "Contenido",

  // ── ML Orders ────────────────────────────────────────────
  "orders.title": "Pedidos de Mercado Libre",
  "orders.noOrders": "No hay pedidos",
  "orders.searchPlaceholder": "Buscar pedidos...",
  "orders.orderId": "ID de Pedido",
  "orders.buyer": "Comprador",
  "orders.product": "Producto",
  "orders.quantity": "Cantidad",
  "orders.total": "Total",
  "orders.date": "Fecha",
  "orders.status": "Estado",
  "orders.shippingStatus": "Estado de envío",

  // ── ML Importer ──────────────────────────────────────────
  "mlImporter.title": "Importador de Mercado Libre",
  "mlImporter.description": "Importa productos desde Mercado Libre a tu catálogo",
  "mlImporter.searchPlaceholder": "Buscar productos en Mercado Libre...",
  "mlImporter.search": "Buscar",
  "mlImporter.searching": "Buscando...",
  "mlImporter.noResults": "No se encontraron resultados",
  "mlImporter.import": "Importar",
  "mlImporter.importing": "Importando...",
  "mlImporter.imported": "Importado",
  "mlImporter.price": "Precio",
  "mlImporter.seller": "Vendedor",
  "mlImporter.condition": "Condición",
  "mlImporter.new": "Nuevo",
  "mlImporter.used": "Usado",

  // ── ML Playground ────────────────────────────────────────
  "mlPlayground.title": "Playground - Mercado Libre",
  "mlPlayground.description": "Experimenta con la API de Mercado Libre",

  // ── Catalog Upload ───────────────────────────────────────
  "catalogUpload.title": "Subir Catálogo",
  "catalogUpload.selectFile": "Seleccionar archivo",
  "catalogUpload.dragDrop": "Arrastra un archivo aquí",
  "catalogUpload.orClick": "o haz clic para seleccionar",
  "catalogUpload.formats": "Formatos: CSV, Excel (.xlsx)",
  "catalogUpload.uploading": "Subiendo...",
  "catalogUpload.success": "Catálogo subido exitosamente",
  "catalogUpload.error": "Error al subir el catálogo",
  "catalogUpload.preview": "Vista previa",
  "catalogUpload.rows": "filas",
  "catalogUpload.columns": "columnas",
  "catalogUpload.upload": "Subir",
  "catalogUpload.mapping": "Mapeo de columnas",
  "catalogUpload.sourceColumn": "Columna de origen",
  "catalogUpload.targetField": "Campo destino",
  "catalogUpload.skip": "Omitir",

  // ── Purchase Intent Stats ────────────────────────────────
  "purchaseIntent.title": "Intención de Compra",
  "purchaseIntent.total": "Total de intenciones",
  "purchaseIntent.converted": "Convertidas",
  "purchaseIntent.pending": "Pendientes",
  "purchaseIntent.conversionRate": "Tasa de conversión",

  // ── Tracked Link Generator ───────────────────────────────
  "trackedLink.title": "Generador de Enlaces Rastreables",
  "trackedLink.baseUrl": "URL base",
  "trackedLink.baseUrlPlaceholder": "https://...",
  "trackedLink.campaign": "Campaña",
  "trackedLink.selectCampaign": "Seleccionar campaña",
  "trackedLink.adSet": "Ad Set",
  "trackedLink.selectAdSet": "Seleccionar ad set",
  "trackedLink.ad": "Anuncio",
  "trackedLink.selectAd": "Seleccionar anuncio",
  "trackedLink.generate": "Generar enlace",
  "trackedLink.generatedLink": "Enlace generado",
  "trackedLink.copy": "Copiar",
  "trackedLink.copied": "¡Copiado!",

  // ── API Health Alerts ────────────────────────────────────
  "apiHealth.title": "Estado de la API",
  "apiHealth.healthy": "API funcionando correctamente",
  "apiHealth.degraded": "API con rendimiento degradado",
  "apiHealth.down": "API no disponible",
  "apiHealth.checking": "Verificando estado de la API...",
  "apiHealth.lastCheck": "Última verificación",
  "apiHealth.responseTime": "Tiempo de respuesta",

  // ── Simulation Mode Selector ─────────────────────────────
  "simulationSelector.title": "Simulación de Rol",
  "simulationSelector.selectRole": "Seleccionar rol",
  "simulationSelector.selectProfile": "Seleccionar perfil",
  "simulationSelector.start": "Simular",
  "simulationSelector.viewing": "Simulando:",
  "simulationSelector.stop": "Detener",

  // ── Product Tree Selector ────────────────────────────────
  "productTreeSelector.title": "Seleccionar Productos",
  "productTreeSelector.searchPlaceholder": "Buscar familia...",
  "productTreeSelector.noFamilies": "No hay familias disponibles",
  "productTreeSelector.selectAll": "Seleccionar todo",
  "productTreeSelector.deselectAll": "Deseleccionar todo",
  "productTreeSelector.selected": "seleccionados",

  // ── Messages Page (extended) ─────────────────────────────
  "messages.loadingConversations": "Cargando conversaciones...",
  "messages.refreshing": "Actualizando...",
  "messages.refresh": "Actualizar",
  "messages.pendingAttention": "Pendientes de Atención",
  "credit.lowBanner": "Crédito de OpenAI bajo: quedan ~{{amount}} (~{{days}} días). En $0 el bot deja de responder.",
  "credit.review": "Ver",
  "credit.lowBannerNoDays": "Crédito de OpenAI bajo: quedan ~{{amount}}. En $0 el bot deja de responder.",
  "messages.coldLeads": "Leads sin contacto",
  "messages.coldLeadsHint": "Dejaron de responder sin dar teléfono ni CP — no se alertó a nadie. Si vuelven a escribir, salen de aquí.",
  "messages.coldSince": "Sin respuesta desde",
  "messages.coldWhy": "Falta",
  "messages.origin": "Origen",
  "messages.show": "Ver",
  "messages.hide": "Ocultar",
  "messages.channel": "Canal",
  "messages.user": "Usuario",
  "messages.waitingSince": "Esperando desde",
  "messages.reason": "Motivo",
  "messages.product": "Producto",
  "messages.city": "Ciudad",
  "messages.intent": "Intención",
  "messages.action": "Acción",
  "messages.afterHours": "Fuera de horario",
  "messages.take": "Tomar",
  "messages.recentActivity": "Actividad Reciente - Últimas 10 Conversaciones",
  "messages.date": "Fecha",
  "messages.lastMessageCol": "Último mensaje",
  "messages.spokesperson": "Vocero",
  "messages.human": "Humano",
  "messages.bot": "Bot",
  "messages.releaseBot": "Liberar",
  "messages.takeOver": "Tomar",
  "messages.releaseToBot": "Liberar al Bot",
  "messages.allConversations": "Todas las Conversaciones",
  "messages.conversationCount": "{{count}} conversación",
  "messages.conversationCountPlural": "{{count}} conversaciones",
  "messages.needsHelp": "{{count}} conversación necesita ayuda",
  "messages.needsHelpPlural": "{{count}} conversaciones necesitan ayuda",
  "messages.filterToday": "Hoy",
  "messages.filterYesterday": "Ayer",
  "messages.filterWeek": "Últimos 7 días",
  "messages.filterMonth": "Últimos 30 días",
  "messages.filterAll": "Todos",
  "messages.senderType": "Tipo",
  "messages.previous": "Anterior",
  "messages.page": "Página {{current}} de {{total}} ({{count}} conversaciones)",
  "messages.next": "Siguiente",
  "messages.conversation": "Conversación",
  "messages.whatsappNote": "WhatsApp • Puedes llamar o enviar mensaje directo",
  "messages.originOrganic": "Orgánico (sin anuncio)",
  "messages.originOrganicHint": "El cliente escribió por su cuenta, no desde un anuncio",
  "messages.originAdInactive": "Este anuncio ya no está activo",
  "messages.replyVia": "Responder por {{channel}}...",
  "messages.status": "Estado",
  "messages.allAds": "Todos los anuncios",
  "messages.resumeBot": "Retomar Bot",
  "messages.resumeBotTitle": "Re-procesar el último mensaje del cliente con el bot",
  "messages.noResponse": "El bot no generó respuesta",
  "messages.closeLink": "Cerrar Enlace",
  "messages.generateLink": "Generar Enlace",
  "messages.close": "Cerrar",
  "messages.copyStoreLink": "Copiar link de tienda ML con PSID",
  "messages.storeLinkCopied": "Link de tienda con PSID copiado",
  "messages.agent": "Agente",
  "messages.numberCopied": "Número copiado: {{number}}",
  "messages.copy": "Copiar",
  "messages.copyNumber": "Copiar número",
  "messages.openWhatsApp": "Abrir en WhatsApp",
  "messages.sendChannel": "Enviar {{icon}}",
  "messages.reportTools": "Opciones de venta / reporte",
  "canned.button": "Respuestas rápidas",
  "canned.search": "Buscar respuesta…",
  "canned.new": "Nueva respuesta",
  "canned.edit": "Editar",
  "canned.delete": "Eliminar",
  "canned.confirmDelete": "¿Eliminar esta respuesta?",
  "canned.empty": "Aún no tienes respuestas guardadas. Crea la primera. 👇",
  "canned.noResults": "Sin coincidencias",
  "canned.titlePlaceholder": "Título corto (ej. Envío)",
  "canned.bodyPlaceholder": "Escribe el mensaje…",
  "canned.cancel": "Cancelar",
  "canned.save": "Guardar",
  "messages.errorSending": "Error enviando mensaje",
  "messages.intentHigh": "Alta",
  "messages.intentMedium": "Media",
  "messages.intentLow": "Baja",
  "messages.handoffUrgent": "Urgente",
  "messages.handoffActionRequired": "Acción Requerida",
  "messages.handoffInfo": "Informativo",
  "messages.agoMinutes": "hace {{count}}min",
  "messages.agoHours": "hace {{count}}h",
  "messages.agoDays": "hace {{count}}d",

  // ── Orders Page (extended) ─────────────────────────────
  "orders.periodOrders": "Pedidos del Periodo",
  "orders.periodRevenue": "Ingresos del Periodo",
  "orders.avgTicket": "Ticket Promedio",
  "orders.fbAttribution": "Atribución Facebook",
  "orders.loading": "Cargando...",
  "orders.calculatingTotal": "Calculando total...",
  "orders.fromCurrentPage": "De página actual",
  "orders.totalFromOrders": "Total de {{count}} pedidos",
  "orders.basedOnPeriod": "Basado en total del periodo",
  "orders.ofOrders": "{{count}} de {{total}} pedidos",
  "orders.topProduct": "Producto Más Vendido",
  "orders.calculating": "Calculando...",
  "orders.units": "{{count}} unidades",
  "orders.orderCount": "{{count}} pedidos",
  "orders.noData": "Sin datos",
  "orders.topBuyer": "Comprador Principal",
  "orders.sellerId": "Seller ID",
  "orders.dateFrom": "Desde",
  "orders.dateTo": "Hasta",
  "orders.searchOrders": "Buscar Pedidos",
  "orders.loadingOrders": "Cargando pedidos...",
  "orders.noOrdersFound": "No hay pedidos",
  "orders.noOrdersDesc": "No se encontraron pedidos para este vendedor",
  "orders.order": "Pedido",
  "orders.more": "+{{count}} más",
  "orders.showing": "Mostrando {{from}} - {{to}} de {{total}} pedidos",
  "orders.maxAccessible": "(máx. {{max}} accesibles)",
  "orders.firstPage": "Primera página",
  "orders.lastPage": "Última página",
  "orders.pageOf": "Página {{current}} de {{total}}",
  "orders.noAuthToken": "No authentication token found. Please login.",

  // ── Conversions Page (extended) ────────────────────────
  "conversions.pageTitle": "Conversiones Meta → Mercado Libre",
  "conversions.pageSubtitle": "Atribución de ventas desde Facebook Messenger",
  "conversions.loadingData": "Cargando datos de conversiones...",
  "conversions.conversions": "Conversiones",
  "conversions.ofClicks": "{{rate}}% de clicks",
  "conversions.attributedRevenue": "Ingresos Atribuidos a FB",
  "conversions.correlatedOrders": "de {{count}} pedidos correlacionados",
  "conversions.clickedLinks": "Links Clickeados",
  "conversions.clickRate": "{{rate}}% click rate",
  "conversions.attributionConfidence": "Confianza Atribución",
  "conversions.high": "Alta",
  "conversions.medium": "Media",
  "conversions.low": "Baja",
  "conversions.chartTitle": "Clicks vs Conversiones por Día",
  "conversions.chartConversions": "Conversiones",
  "conversions.chartClicks": "Clicks",
  "conversions.correlation": "Correlación",
  "conversions.from": "Desde",
  "conversions.to": "Hasta",
  "conversions.windowHours": "Ventana (hrs)",
  "conversions.limit": "Límite",
  "conversions.updateStats": "Actualizar Stats",
  "conversions.preview": "Vista Previa",
  "conversions.syncNow": "Sincronizar Ahora",
  "conversions.processing": "Procesando...",
  "conversions.previewTitle": "Vista Previa (sin guardar)",
  "conversions.correlationComplete": "Correlación Completada",
  "conversions.ordersProcessed": "Pedidos procesados:",
  "conversions.withClicks": "Con clicks:",
  "conversions.clicksCorrelated": "Clicks correlacionados:",
  "conversions.matchRate": "Tasa de match:",
  "conversions.correlationsFound": "Correlaciones encontradas:",
  "conversions.topBuyers": "Top Compradores",
  "conversions.purchaseCount": "{{count}} compra",
  "conversions.purchaseCountPlural": "{{count}} compras",
  "conversions.userDefault": "Usuario",
  "conversions.recentConversions": "Conversiones Recientes",
  "conversions.show": "Mostrar:",
  "conversions.noConversionsRecorded": "No hay conversiones registradas",
  "conversions.colProduct": "Producto",
  "conversions.colBuyer": "Comprador",
  "conversions.colCity": "Ciudad",
  "conversions.colClick": "Click",
  "conversions.colOrder": "Pedido",
  "conversions.colMethod": "Método",
  "conversions.colDetail": "Detalle",
  "conversions.colAmount": "Monto",
  "conversions.colConfidence": "Confianza",
  "conversions.showingRange": "Mostrando {{from}} - {{to}} de {{total}}",
  "conversions.pageOf": "Página {{current}} de {{total}}",
  "conversions.funnelTitle": "Funnel de Atribución",
  "conversions.linksGenerated": "Links Generados",
  "conversions.clicks": "Clicks",
  "conversions.funnelConversions": "Conversiones",
  "conversions.fbRevenue": "Ingresos FB",
  "conversions.orders": "{{count}} pedidos",

  // ── Inventory Page (extended) ──────────────────────────
  "inventory.sellableProducts": "{{count}} productos vendibles",
  "inventory.searchPlaceholderFull": "Buscar por nombre, medida o color...",
  "inventory.syncML": "Sync ML",
  "inventory.syncing": "Sincronizando...",
  "inventory.synced": "{{count}} sincronizados",
  "inventory.errors": "{{count}} errores",
  "inventory.deactivateUnpriced": "Desactivar sin precio",
  "inventory.exportExcel": "Exportar Excel",
  "inventory.uploadPrices": "Actualizar precios (Excel)",
  "inventory.uploading": "Subiendo…",
  "inventory.uploadDone": "Precios: {{price}} · Links: {{link}} · Sin cambios: {{unchanged}}",
  "inventory.uploadNotFound": "No encontrados: {{count}}",
  "inventory.uploadInvalid": "Sin precio válido: {{count}}",
  "inventory.pasteMLLabel": "O pega el link de Mercado Libre directamente",
  "inventory.saveLink": "Guardar link",
  "inventory.invalidMLUrl": "El link debe ser una URL de Mercado Libre",
  "inventory.selected": "{{count}} seleccionados",
  "inventory.operation": "Operación...",
  "inventory.opPrice": "Precio",
  "inventory.opStock": "Stock",
  "inventory.opActivate": "Activar",
  "inventory.opDeactivate": "Desactivar",
  "inventory.apply": "Aplicar",
  "inventory.loadingInventory": "Cargando inventario...",
  "inventory.noProductsFound": "No se encontraron productos",
  "inventory.productsCount": "{{count}} productos",
  "inventory.colCode": "Código",
  "inventory.colProduct": "Producto",
  "inventory.colSize": "Medida",
  "inventory.colColor": "Color",
  "inventory.colStock": "Stock",
  "inventory.colPrice": "Precio",
  "inventory.colMinQty": "Min Qty",
  "inventory.colWholesale": "Mayoreo",
  "inventory.colActive": "Activo",
  "inventory.importFromML": "Importar desde Mercado Libre",
  "inventory.linking": "Vinculando:",
  "inventory.searchMinChars": "Escribe al menos 3 caracteres para buscar...",
  "inventory.searchMinCharsML": "Escribe al menos 3 caracteres para buscar productos en ML",
  "inventory.searching": "Buscando...",
  "inventory.showingOf": "Mostrando {{shown}} de {{total}} resultados",
  "inventory.noMLProducts": "No se encontraron productos",
  "inventory.cancel": "Cancelar",
  "inventory.linkML": "Vincular",
  "inventory.changeMLLink": "Cambiar enlace ML",
  "inventory.importML": "Importar desde ML",
  "inventory.selectAtLeast": "Selecciona al menos un producto",
  "inventory.selectOperation": "Selecciona una operación",
  "inventory.enterValidValue": "Ingresa un valor válido",
  "inventory.someUpdatesFailed": "Algunos productos no se pudieron actualizar",
  "inventory.errorUpdating": "Error al actualizar",
  "inventory.errorUpdateProduct": "Error al actualizar: ",
  "inventory.noUnconfirmed": "No hay productos con precios sin confirmar",
  "inventory.deactivateConfirm": "¿Desactivar {{count}} productos sin precio confirmado?",
  "inventory.errorDeactivating": "Error al desactivar productos",
  "inventory.errorLinking": "Error al vincular: ",
  "inventory.errorLinkingProduct": "Error al vincular producto",
  "inventory.confirmPrice": "Confirmar precio",
  "inventory.errorSyncPrices": "Error al sincronizar precios: ",
  "inventory.errorSyncPricesML": "Error al sincronizar precios de ML",
  "inventory.view": "Ver",

  // ── ML Importer Page (extended) ────────────────────────
  "mlImporter.pageTitle": "Importador ML",
  "mlImporter.pageSubtitle": "Vincula productos de Mercado Libre con tu inventario",
  "mlImporter.totalML": "Total ML:",
  "mlImporter.linked": "Vinculados:",
  "mlImporter.unlinked": "Sin vincular:",
  "mlImporter.unavailable": "No disponible:",
  "mlImporter.inactive": "Inactivos:",
  "mlImporter.updateML": "Actualizar ML",
  "mlImporter.loadingML": "Cargando productos de Mercado Libre... (esto puede tardar unos segundos)",
  "mlImporter.loadingInventory": "Cargando inventario...",
  "mlImporter.searchML": "Buscar en ML...",
  "mlImporter.filterAll": "Todos",
  "mlImporter.filterUnlinked": "Sin vincular",
  "mlImporter.filterLinked": "Vinculados",
  "mlImporter.filterInactive": "Inactivos",
  "mlImporter.noProductsFound": "No se encontraron productos",
  "mlImporter.notAvailable": "No disponible",
  "mlImporter.inactiveLabel": "Inactivo",
  "mlImporter.linkedLabel": "Vinculado",
  "mlImporter.viewInML": "Ver en ML",
  "mlImporter.linkedTo": "Vinculado a:",
  "mlImporter.pausedInML": "Pausado en ML",
  "mlImporter.reactivate": "Reactivar",
  "mlImporter.unlink": "Desvincular",
  "mlImporter.deactivate": "Inactivar",
  "mlImporter.link": "Vincular",
  "mlImporter.linkMLProduct": "Vincular producto ML",
  "mlImporter.searchInventory": "Buscar producto en inventario...",
  "mlImporter.alreadyHasML": "Ya tiene link ML",
  "mlImporter.showingOf": "Mostrando {{shown}} de {{total}} resultados",
  "mlImporter.cancel": "Cancelar",
  "mlImporter.unlinkConfirm": "¿Desvincular este producto de ML?",
  "mlImporter.errorLoading": "Error cargando ML: ",
  "mlImporter.connectionError": "Error de conexión: ",
  "mlImporter.errorLinking": "Error al vincular: ",
  "mlImporter.errorLinkingProduct": "Error al vincular producto",
  "mlImporter.errorUnlinking": "Error al desvincular: ",
  "mlImporter.errorUnlinkingProduct": "Error al desvincular producto",

  // ── ML Playground Page (extended) ──────────────────────
  "mlPlayground.pageTitle": "ML API Playground",
  "mlPlayground.pageSubtitle": "Prueba integraciones con Mercado Libre",
  "mlPlayground.connectionStatus": "Estado de Conexion",
  "mlPlayground.connectedAs": "Conectado como {{nickname}} ({{id}})",
  "mlPlayground.notConnected": "No conectado",
  "mlPlayground.verifying": "Verificando...",
  "mlPlayground.verify": "Verificar",
  "mlPlayground.itemsInML": "Items en ML",
  "mlPlayground.loadItems": "Cargar Items",
  "mlPlayground.loadingItems": "Cargando...",
  "mlPlayground.searchPlaceholder": "Buscar por titulo, ID o SKU...",
  "mlPlayground.clickToLoad": "Haz clic en \"Cargar Items\" para ver tus publicaciones",
  "mlPlayground.noItemsFound": "No se encontraron items",
  "mlPlayground.itemDetails": "Detalles del Item",
  "mlPlayground.selectItem": "Selecciona un item para ver sus detalles",
  "mlPlayground.viewInML": "Ver en ML",
  "mlPlayground.currentPrice": "Precio actual:",
  "mlPlayground.originalPrice": "Precio original:",
  "mlPlayground.status": "Estado:",
  "mlPlayground.available": "Disponibles:",
  "mlPlayground.sold": "Vendidos:",
  "mlPlayground.sku": "SKU:",
  "mlPlayground.updatePrice": "Actualizar Precio",
  "mlPlayground.newPricePlaceholder": "Nuevo precio",
  "mlPlayground.updating": "Actualizando...",
  "mlPlayground.update": "Actualizar",
  "mlPlayground.priceNote": "Nota: Si el item tiene promocion activa, el precio puede no actualizarse.",
  "mlPlayground.invalidPrice": "Precio invalido",
  // eslint-disable-next-line no-template-curly-in-string
  "mlPlayground.priceUpdated": "Precio actualizado a ${{price}}",
  "mlPlayground.errorUpdatePrice": "Error updating price",
  "mlPlayground.errorStatus": "Error checking ML status",
  "mlPlayground.errorItems": "Error fetching items",
  "mlPlayground.errorDetails": "Error fetching item details",
  "mlPlayground.apiLog": "API Log",
  "mlPlayground.clearLog": "Limpiar",
  "mlPlayground.noActivity": "No hay actividad registrada",

  // ── Puntos de Venta Page (extended) ────────────────────
  "pos.pageTitle": "Puntos de Venta",
  "pos.pageSubtitle": "Gestiona las tiendas online donde se venden los productos",
  "pos.newPOS": "Nuevo Punto de Venta",
  "pos.listTitle": "Lista de Puntos de Venta",
  "pos.loadingPOS": "Cargando puntos de venta...",
  "pos.noPOSRegistered": "No hay puntos de venta registrados",
  "pos.startAdding": "Comienza agregando el primer punto de venta",
  "pos.addPOSButton": "Agregar Punto de Venta",
  "pos.nameCol": "Nombre",
  "pos.baseUrl": "URL Base",
  "pos.descriptionCol": "Descripción",
  "pos.actionsCol": "Acciones",
  "pos.inactiveLabel": "Inactivo",
  "pos.editTooltip": "Editar",
  "pos.deleteTooltip": "Eliminar",

  // ── Home Page ────────────────────────────────────────────
  "home.welcome": "Bienvenido",
  "home.subtitle": "Panel de administración de Hanlob Bot",

  // ── CampaignModal extras ───────────────────────────────
  "campaignModal.refLabel": "Referencia (Ref) *",
  "campaignModal.refPlaceholder": "malla_agricola_2025",
  "campaignModal.refHint": "URL: ?ref=valor",
  "campaignModal.nameRequired": "Nombre *",
  "campaignModal.namePlaceholderExample": "Malla Sombra Agrícola",
  "campaignModal.trafficSource": "Fuente de Tráfico",
  "campaignModal.conversationGoal": "Meta de Conversación",
  "campaignModal.activeCheckbox": "Activa",
  "campaignModal.startDateLabel": "Fecha Inicio",
  "campaignModal.endDateLabel": "Fecha Fin",
  "campaignModal.initialMessage": "Mensaje Inicial",
  "campaignModal.initialMessagePlaceholder": "¡Hola! Vi que te interesa la malla sombra...",
  "campaignModal.adAngle": "Ángulo del Anuncio",
  "campaignModal.selectOption": "Seleccionar...",
  "campaignModal.adSummary": "Resumen del Anuncio",
  "campaignModal.adSummaryPlaceholder": "Protección solar para evitar quemaduras en cultivos",
  "campaignModal.adSummaryHint": "Breve descripción del mensaje del anuncio",
  "campaignModal.ctaLabel": "Call to Action (CTA)",
  "campaignModal.offerHook": "Oferta/Gancho",
  "campaignModal.audienceType": "Tipo de Audiencia",
  "campaignModal.experienceLevel": "Nivel de Experiencia",
  "campaignModal.audienceNoteTitle": "Nota sobre la audiencia",
  "campaignModal.audienceNoteText": "El tipo de audiencia ayuda al bot a ajustar el tono y las recomendaciones. Por ejemplo, un agricultor recibe información técnica mientras que un hogar recibe consejos prácticos.",
  "campaignModal.productsTitle": "Productos de la Campaña",
  "campaignModal.productsHint": "Selecciona los productos disponibles en esta campaña",
  "campaignModal.responseTone": "Tono de Respuesta",
  "campaignModal.mustNot": "El bot NO DEBE...",
  "campaignModal.selectRule": "Seleccionar regla...",
  "campaignModal.shouldDo": "El bot DEBE...",
  "campaignModal.catalogSaveFirst": "Primero guarda la campaña para poder subir un catálogo.",
  "campaignModal.catalogNoteTitle": "Nota sobre catálogos",
  "campaignModal.catalogNoteText": "El catálogo subido aquí estará disponible para todos los AdSets y Ads de esta campaña, a menos que se suba un catálogo específico a nivel de AdSet o Ad.",
  "campaignModal.fbAdAccountId": "FB Ad Account ID",
  "campaignModal.objectiveLabel": "Objetivo",
  "campaignModal.dailyBudget": "Presupuesto Diario ($)",
  "campaignModal.lifetimeBudget": "Presupuesto Total ($)",
  "campaignModal.statusActive": "Activa",
  "campaignModal.statusPaused": "Pausada",
  "campaignModal.statusArchived": "Archivada",
  "campaignModal.objectiveTraffic": "Tráfico",
  "campaignModal.objectiveLeads": "Leads",
  "campaignModal.objectiveSales": "Ventas",
  "campaignModal.objectiveEngagement": "Engagement",
  "campaignModal.update": "Actualizar",
  "campaignModal.tabBasic": "Básico",
  "campaignModal.tabAd": "Anuncio",
  "campaignModal.tabAudience": "Audiencia",
  "campaignModal.tabProducts": "Productos",
  "campaignModal.tabGuidelines": "Guías IA",
  "campaignModal.tabCatalog": "Catálogo",
  "campaignModal.tabFacebook": "Facebook",
  "campaignModal.refRequired": "Por favor ingresa un valor para el campo \"Ref\"",

  // ── AdModal extras ─────────────────────────────────────
  "adModal.nameRequired": "Nombre *",
  "adModal.fbAdIdRequired": "FB Ad ID *",
  "adModal.adSetRequired": "Ad Set *",
  "adModal.selectAdSetOption": "Selecciona un ad set",
  "adModal.statusActive": "Activo",
  "adModal.statusPaused": "Pausado",
  "adModal.statusArchived": "Archivado",
  "adModal.creativeContent": "Contenido Creativo",
  "adModal.descriptionLabel": "Descripción",
  "adModal.descriptionPlaceholder": "Envío gratis a todo México",
  "adModal.callToActionLabel": "Call to Action",
  "adModal.ctaLearnMore": "Más información",
  "adModal.ctaShopNow": "Comprar ahora",
  "adModal.ctaSignUp": "Registrarse",
  "adModal.ctaContactUs": "Contáctanos",
  "adModal.ctaGetQuote": "Solicitar cotización",
  "adModal.destinationUrl": "URL de Destino",
  "adModal.botCustomization": "Personalización de Respuestas del Bot",
  "adModal.botCustomizationHint": "Estos campos ayudan al bot a personalizar sus respuestas según el contexto del anuncio.",
  "adModal.adAngle": "Ángulo del Anuncio",
  "adModal.noAngle": "Sin ángulo específico",
  "adModal.primaryUse": "Uso Principal",
  "adModal.primaryUsePlaceholder": "ej: protección solar agrícola, sombra para patio",
  "adModal.audienceTypeLabel": "Tipo de Audiencia",
  "adModal.audienceTypePlaceholder": "ej: agricultor/vivero, dueño de casa, negocio",
  "adModal.offerHookLabel": "Gancho de Oferta",
  "adModal.offerHookPlaceholder": "ej: envío gratis por tiempo limitado, 10% descuento esta semana",
  "adModal.offerHookHint": "Este texto se agregará al final de las respuestas del bot cuando sea relevante.",
  "adModal.associatedProducts": "Productos Asociados",
  "adModal.productsNote": "Nota: Deja vacío para usar los productos del AdSet o Campaña. Solo se guardarán los productos vendibles seleccionados.",
  "adModal.mainProduct": "Producto Principal (para detección de interés)",
  "adModal.useFirstProduct": "Usar primer producto de la lista",
  "adModal.mainProductHint": "Este producto determina cómo el bot identifica el tipo de producto del anuncio.",
  "adModal.catalogSaveFirst": "Primero guarda el Anuncio para poder subir un catálogo.",
  "adModal.updateAd": "Actualizar",
  "adModal.videoUrl": "URL de Video",
  "adModal.tracking": "Tracking (UTMs)",
  "adModal.trackingHint": "Parámetros UTM para rastreo de campañas",
  "adModal.utmSource": "utm_source",
  "adModal.utmMedium": "utm_medium",
  "adModal.utmCampaign": "utm_campaign",
  "adModal.utmContent": "utm_content",
  "adModal.utmTerm": "utm_term",

  // ── IntentModal extras ─────────────────────────────────
  "intentModal.handlerAiGenerate": "IA genera respuesta",
  "intentModal.handlerAiGenerateDesc": "El bot usa IA para generar una respuesta contextual",
  "intentModal.handlerAutoResponse": "Respuesta automática",
  "intentModal.handlerAutoResponseDesc": "Usa el template de respuesta definido",
  "intentModal.handlerFlow": "Flujo conversacional",
  "intentModal.handlerFlowDesc": "Inicia un flujo de conversación específico",
  "intentModal.handlerHumanHandoff": "Transferir a humano",
  "intentModal.handlerHumanHandoffDesc": "Transfiere la conversación a un agente humano",
  "intentModal.keyLabel": "Key (identificador) *",
  "intentModal.keyPlaceholder": "price_query",
  "intentModal.keyHint": "Identificador único (minúsculas y _)",
  "intentModal.nameRequired": "Nombre *",
  "intentModal.descPlaceholder": "Describe cuándo se activa este intent (usado por la IA para clasificar)",
  "intentModal.intentActive": "Intent activo",
  "intentModal.intentActiveHint": "Solo los intents activos son usados por el clasificador",
  "intentModal.priorityLabel": "Prioridad: {{value}}",
  "intentModal.priorityLow": "1 (Baja)",
  "intentModal.priorityHigh": "10 (Alta)",
  "intentModal.priorityHint": "Mayor prioridad = se considera primero cuando múltiples intents pueden coincidir",
  "intentModal.keywordsLabel": "Palabras clave",
  "intentModal.keywordPlaceholder": "Escribe una palabra clave y presiona Enter",
  "intentModal.keywordsHint": "Las palabras clave ayudan al clasificador a detectar este intent",
  "intentModal.regexPatterns": "Patrones Regex (Avanzado)",
  "intentModal.regexHint": "Patrones regex opcionales para detección rápida sin IA",
  "intentModal.responseType": "Tipo de respuesta",
  "intentModal.flowToExecute": "Flujo a ejecutar",
  "intentModal.selectFlow": "-- Selecciona un flujo --",
  "intentModal.noFlows": "No hay flujos creados. Ve a la sección Flows para crear uno.",
  "intentModal.flowLinked": "Este intent iniciará el flujo seleccionado cuando sea detectado.",
  "intentModal.responseTemplate": "Template de respuesta",
  "intentModal.responseTemplatePlaceholder": "Respuesta predeterminada cuando se detecta este intent (usado por auto_response)",
  "intentModal.responseAutoHint": "Esta respuesta se enviará automáticamente cuando se detecte el intent",
  "intentModal.responseFlowHint": "Opcional: mensaje de bienvenida antes de iniciar el flujo",
  "intentModal.responseAiHint": "Opcional: puede usarse como contexto para la IA",
  "intentModal.timesDetected": "Veces detectado",
  "intentModal.lastDetection": "Última detección",
  "intentModal.never": "Nunca",
  "intentModal.created": "Creado",
  "intentModal.lastModified": "Última modificación",
  "intentModal.saveChanges": "Guardar Cambios",
  "intentModal.createIntent": "Crear Intent",
  "intentModal.tabBasic": "Básico",
  "intentModal.tabClassification": "Clasificación",
  "intentModal.tabResponse": "Respuesta",
  "intentModal.tabStats": "Estadísticas",
  "intentModal.validationRequired": "Por favor completa la key y el nombre",
  "intentModal.validationKeyFormat": "La key solo puede contener letras minúsculas, números y guiones bajos, y debe comenzar con letra",
  "intentModal.invalidRegex": "Patrón regex inválido: ",

  // ── IntentsView extras ─────────────────────────────────
  "intentsView.title": "Gestión de Intents",
  "intentsView.subtitle": "Configura las intenciones que el bot puede detectar",
  "intentsView.newCategory": "Nueva Categoría",
  "intentsView.newIntent": "Nuevo Intent",
  "intentsView.intentsTab": "Intents",
  "intentsView.categoriesTab": "Categorías",
  "intentsView.searchPlaceholder": "Buscar por nombre, key o keywords...",
  "intentsView.allCategories": "Todas las categorías",
  "intentsView.allStatuses": "Todos los estados",
  "intentsView.statusActive": "Activos",
  "intentsView.statusInactive": "Inactivos",
  "intentsView.totalIntents": "Total Intents",
  "intentsView.active": "Activos",
  "intentsView.categories": "Categorías",
  "intentsView.totalHits": "Hits Totales",
  "intentsView.loadingIntents": "Cargando intents...",
  "intentsView.noIntents": "No hay intents",
  "intentsView.noResults": "Sin resultados",
  "intentsView.createFirst": "Crea el primer intent del sistema",
  "intentsView.tryOtherFilters": "Intenta con otros filtros de búsqueda",
  "intentsView.more": "+{{count}} más",
  "intentsView.intentUpdated": "Intent actualizado correctamente",
  "intentsView.intentCreated": "Intent creado correctamente",
  "intentsView.errorSaveIntent": "Error al guardar intent",
  "intentsView.confirmDeleteIntent": "¿Estás seguro de eliminar este intent?",
  "intentsView.intentDeleted": "Intent eliminado correctamente",
  "intentsView.errorDeleteIntent": "Error al eliminar intent",
  "intentsView.intentActivated": "Intent activado",
  "intentsView.intentDeactivated": "Intent desactivado",
  "intentsView.errorToggle": "Error al cambiar estado",
  "intentsView.categoryUpdated": "Categoría actualizada",
  "intentsView.categoryCreated": "Categoría creada",
  "intentsView.errorSaveCategory": "Error al guardar categoría",
  "intentsView.confirmDeleteCategory": "¿Estás seguro de eliminar esta categoría?",
  "intentsView.categoryDeleted": "Categoría eliminada",
  "intentsView.errorDeleteCategory": "Error al eliminar categoría",
  "intentsView.errorLoadIntents": "Error al cargar intents",
  "intentsView.noCategories": "No hay categorías",
  "intentsView.createFirstCategory": "Crea la primera categoría",
  "intentsView.intentsCount": "{{count}} intents",
  "intentsView.handlerAutoResponse": "Respuesta automática",
  "intentsView.handlerFlow": "Flujo",
  "intentsView.handlerHumanHandoff": "Transferir a humano",
  "intentsView.handlerAiGenerate": "IA genera respuesta",

  // ── CampaignsView extras ───────────────────────────────
  "campaignsView.title": "Campañas",
  "campaignsView.subtitle": "Gestiona las campañas de Facebook/Instagram",
  "campaignsView.newCampaign": "Nueva Campaña",
  "campaignsView.campaignList": "Lista de Campañas",
  "campaignsView.loadingCampaigns": "Cargando campañas...",
  "campaignsView.noCampaigns": "No hay campañas",
  "campaignsView.startCreating": "Comienza creando tu primera campaña",
  "campaignsView.addCampaign": "Agregar Campaña",
  "campaignsView.thName": "Nombre",
  "campaignsView.thStatus": "Estado",
  "campaignsView.thMetrics": "Métricas",
  "campaignsView.thDates": "Fechas",
  "campaignsView.thActions": "Acciones",
  "campaignsView.active": "Activa",
  "campaignsView.inactive": "Inactiva",
  "campaignsView.detailsTitle": "Detalles de la Campaña",
  "campaignsView.basicInfo": "Información Básica",
  "campaignsView.reference": "Referencia",
  "campaignsView.fbConfig": "Configuración de Facebook",
  "campaignsView.budget": "Presupuesto",
  "campaignsView.daily": "Diario",
  "campaignsView.totalBudget": "Total",
  "campaignsView.dates": "Fechas",
  "campaignsView.startDate": "Inicio",
  "campaignsView.endDate": "Fin",
  "campaignsView.botConfig": "Configuración del Bot",
  "campaignsView.defaultFlow": "Flujo Predeterminado",
  "campaignsView.conversionGoal": "Meta de Conversión",
  "campaignsView.productFocus": "Producto Focus",
  "campaignsView.initialMessage": "Mensaje Inicial",
  "campaignsView.metricsTitle": "Métricas",
  "campaignsView.visits": "Visitas",
  "campaignsView.interactions": "Interacciones",
  "campaignsView.clicks": "Clicks",
  "campaignsView.leads": "Leads",
  "campaignsView.conversions": "Conversiones",
  "campaignsView.internalId": "ID Interno",
  "campaignsView.objective": "Objetivo",
  "campaignsView.statusFb": "Status FB",

  // ── CatalogUpload extras ───────────────────────────────
  "catalogUpload.pdfLabel": "Catálogo PDF",
  "catalogUpload.useExisting": "Usar catálogo existente...",
  "catalogUpload.orUploadNew": "o subir nuevo:",
  "catalogUpload.cover": "Portada",
  "catalogUpload.inheritedFrom": "Heredado de: {{source}}",
  "catalogUpload.uploaded": "Subido: {{date}}",
  "catalogUpload.viewCatalog": "Ver catálogo",
  "catalogUpload.deleteCatalog": "Eliminar catálogo",
  "catalogUpload.uploadingCatalog": "Subiendo catálogo...",
  "catalogUpload.replaceCatalog": "Reemplazar catálogo",
  "catalogUpload.uploadPdf": "Subir catálogo PDF",
  "catalogUpload.dragOrClick": "Arrastra o haz clic para seleccionar (máx. 10MB)",
  "catalogUpload.overrideInherited": "Subir catálogo propio para sobrescribir el heredado",
  "catalogUpload.onlyPdf": "Solo se permiten archivos PDF",
  "catalogUpload.maxSize": "El archivo no puede ser mayor a 10MB",
  "catalogUpload.confirmDelete": "¿Eliminar este catálogo?",

  // ── CampaignTreeView extras ────────────────────────────
  "campaignTree.mainTitle": "Campañas Publicitarias",
  "campaignTree.mainSubtitle": "Gestiona campañas, conjuntos de anuncios y anuncios",
  "campaignTree.newCampaign": "Nueva Campaña",
  "campaignTree.searchPlaceholderFull": "Buscar por ID, fbCampaignId, ref o nombre...",
  "campaignTree.loading": "Cargando campañas...",
  "campaignTree.noResults": "No se encontraron resultados",
  "campaignTree.noCampaignsFound": "No se encontraron campañas",
  "campaignTree.noMatchQuery": "No hay campañas que coincidan con \"{{query}}\"",
  "campaignTree.startAdding": "Comienza agregando tu primera campaña publicitaria",
  "campaignTree.addCampaignBtn": "Agregar Campaña",
  "campaignTree.activeCampaigns": "Activas",
  "campaignTree.inactiveCampaigns": "Pausadas / Inactivas",
  "campaignTree.typeCampaign": "Campaña",
  "campaignTree.typeAdSet": "Conjunto",
  "campaignTree.typeAd": "Anuncio",
  "campaignTree.typeItem": "Item",
  "campaignTree.noName": "Sin nombre",
  "campaignTree.addAdSetTooltip": "Agregar Conjunto de Anuncios",
  "campaignTree.addAdTooltip": "Agregar Anuncio",
  "campaignTree.viewDetails": "Ver Detalles",
  "campaignTree.deactivateCampaign": "Desactivar campaña",
  "campaignTree.activateCampaign": "Activar campaña",
  "campaignTree.impressions": "impresiones",
  "campaignTree.clicks": "clics",
  "campaignTree.spent": "gastado",
  "campaignTree.conversionsLabel": "conversiones",
  "campaignTree.dailyBudget": "Presupuesto diario",
  "campaignTree.lifetimeBudget": "Presupuesto total",
  "campaignTree.campaignActivated": "Campaña activada",
  "campaignTree.campaignDeactivated": "Campaña desactivada",
  "campaignTree.errorToggle": "Error al cambiar estado",
  "campaignTree.contract": "Contraer",
  "campaignTree.expandNode": "Expandir",
  "campaignTree.viewDetailsTooltip": "Ver detalles",
  "campaignTree.activeFem": "Activa",
  "campaignTree.inactiveFem": "Inactiva",

  // ── Ads View (extended) ─────────────────────────────────
  "ads.groupedByCampaign": "Agrupados por campaña y ad set",
  "ads.loading": "Cargando anuncios...",
  "ads.emptyDescription": "Los anuncios se crearán automáticamente con las campañas",
  "ads.activeCount": "activos",
  "ads.adDetails": "Detalles del Anuncio",
  "ads.basicInfo": "Información Básica",
  "ads.associatedProducts": "Productos Asociados",
  "ads.productsCount": "productos",
  "ads.internalId": "ID Interno",
  "ads.creative": "Creatividad",
  "ads.mainText": "Texto Principal",
  "ads.callToAction": "Call to Action",
  "ads.destinationUrl": "URL de Destino",
  "ads.video": "Video",
  "ads.trackingSection": "Seguimiento",
  "ads.botCustomization": "Personalización del Bot",
  "ads.adAngle": "Ángulo del Anuncio",
  "ads.audienceType": "Tipo de Audiencia",
  "ads.primaryUse": "Uso Principal",
  "ads.offerHook": "Gancho de Oferta",
  "ads.notConfigured": "No configurado",
  "ads.anglePriceSensitive": "Precio - Enfoque en valor/precio accesible",
  "ads.angleQualityPremium": "Calidad Premium - Enfoque en durabilidad",
  "ads.angleUrgencyOffer": "Urgencia - Oferta por tiempo limitado",
  "ads.angleProblemPain": "Problema/Dolor - Solución al sol/calor",
  "ads.angleBulkB2b": "Mayoreo/B2B - Enfoque en negocios",
  "ads.angleDiyEase": "Fácil Instalación - Hazlo tú mismo",
  "ads.angleComparisonSwitching": "Comparación - Mejor que alternativas",
  "ads.metricsSection": "Métricas",
  "ads.impressionsLabel": "Impresiones",
  "ads.clicksLabel": "Clicks",
  "ads.conversionsLabel": "Conversiones",
  "ads.spendLabel": "Gasto",
  "ads.reachLabel": "Alcance",
  "ads.ctrLabel": "CTR",
  "ads.cpcLabel": "CPC",
  "ads.cpmLabel": "CPM",
  "ads.systemInfo": "Información de Sistema",
  "ads.createdAt": "Creado",
  "ads.updatedAt": "Actualizado",
  "ads.updatedSuccess": "Anuncio actualizado correctamente",
  "ads.createdSuccess": "Anuncio creado correctamente",
  "ads.errorSave": "Error al guardar el anuncio",
  "ads.errorSaveDetail": "Error al guardar el anuncio: ",
  "ads.errorUnknown": "Error desconocido",
  "ads.statusUpdated": "Estado actualizado correctamente",
  "ads.errorUpdateStatus": "Error al actualizar estado",
  "ads.errorUpdateStatusDetail": "Error al actualizar estado: ",
  "ads.statusActive": "Activo",
  "ads.statusPaused": "Pausado",
  "ads.statusArchived": "Archivado",
  "ads.viewDetails": "Ver Detalles",
  "ads.noCampaign": "Sin Campaña",
  "ads.noAdSet": "Sin Ad Set",

  // ── Ad Set Modal (extended) ────────────────────────────
  "adSetModal.fbAdSetId": "FB AdSet ID",
  "adSetModal.selectCampaignOption": "Selecciona una campaña",
  "adSetModal.statusActive": "Activo",
  "adSetModal.statusPaused": "Pausado",
  "adSetModal.statusArchived": "Archivado",
  "adSetModal.dailyBudget": "Presupuesto Diario ($)",
  "adSetModal.locations": "Ubicaciones (separadas por comas)",
  "adSetModal.ageMin": "Edad Mín",
  "adSetModal.ageMax": "Edad Máx",
  "adSetModal.optimizationGoal": "Objetivo de Optimización",
  "adSetModal.billingEvent": "Evento de Facturación",
  "adSetModal.placements": "Ubicaciones de Anuncios (separadas por comas)",
  "adSetModal.associatedProducts": "Productos Asociados",
  "adSetModal.productsNote": "Nota: Deja vacío para usar los productos de la campaña. Solo se guardarán los productos vendibles seleccionados.",
  "adSetModal.saveCatalogFirst": "Primero guarda el Ad Set para poder subir un catálogo.",
  "adSetModal.update": "Actualizar",
  "adSetModal.genders": "Géneros",
  "adSetModal.gendersPlaceholder": "Hombres, Mujeres o todos",
  "adSetModal.interests": "Intereses",
  "adSetModal.interestsPlaceholder": "Agricultura, Jardinería, Construcción",
  "adSetModal.behaviors": "Comportamientos",
  "adSetModal.behaviorsPlaceholder": "Compradores frecuentes",
  "adSetModal.customAudiences": "Audiencias Personalizadas",
  "adSetModal.customAudiencesPlaceholder": "Lookalike MX 1%, Retargeting 30d",

  // ── Ad Sets View (extended) ────────────────────────────
  "adSets.groupedByCampaign": "Agrupados por campaña",
  "adSets.loading": "Cargando ad sets...",
  "adSets.emptyDescription": "Los ad sets se crearán automáticamente con las campañas",
  "adSets.activeAds": "anuncios activos",
  "adSets.noAdsInSet": "No hay anuncios en este ad set",
  "adSets.adSetDetails": "Detalles del Ad Set",
  "adSets.basicInfo": "Información Básica",
  "adSets.internalId": "ID Interno",
  "adSets.locations": "Ubicaciones",
  "adSets.age": "Edad",
  "adSets.gender": "Género",
  "adSets.interests": "Intereses",
  "adSets.budgetAndOptimization": "Presupuesto y Optimización",
  "adSets.dailyBudget": "Presupuesto Diario",
  "adSets.lifetimeBudget": "Presupuesto Total",
  "adSets.optimizationGoal": "Objetivo de Optimización",
  "adSets.billingEvent": "Evento de Facturación",
  "adSets.bid": "Puja",
  "adSets.metricsSection": "Métricas",
  "adSets.impressionsLabel": "Impresiones",
  "adSets.clicksLabel": "Clicks",
  "adSets.conversionsLabel": "Conversiones",
  "adSets.spendLabel": "Gasto",
  "adSets.reachLabel": "Alcance",
  "adSets.ctrLabel": "CTR",
  "adSets.updatedSuccess": "Ad Set actualizado correctamente",
  "adSets.createdSuccess": "Ad Set creado correctamente",
  "adSets.errorSave": "Error al guardar el ad set",
  "adSets.errorSaveDetail": "Error al guardar el ad set: ",
  "adSets.adUpdatedSuccess": "Anuncio actualizado correctamente",
  "adSets.adCreatedSuccess": "Anuncio creado correctamente",
  "adSets.adErrorSave": "Error al guardar el anuncio",
  "adSets.adErrorSaveDetail": "Error al guardar el anuncio: ",
  "adSets.statusUpdated": "Estado actualizado",
  "adSets.errorUpdateStatus": "Error al actualizar estado",
  "adSets.statusActive": "Activo",
  "adSets.statusPaused": "Pausado",
  "adSets.viewDetails": "Ver Detalles",
  "adSets.noCampaign": "Sin Campaña",
  "adSets.targetingSection": "Segmentación",

  // ── Flow Modal (extended) ──────────────────────────────
  "flowModal.inputTypeText": "Texto libre",
  "flowModal.inputTypeOptions": "Opciones",
  "flowModal.inputTypeNumber": "Número",
  "flowModal.inputTypePhone": "Teléfono",
  "flowModal.inputTypeEmail": "Email",
  "flowModal.inputTypeConfirm": "Confirmación (Sí/No)",
  "flowModal.actionMessage": "Enviar mensaje",
  "flowModal.actionHandoff": "Transferir a humano",
  "flowModal.actionFlow": "Iniciar otro flow",
  "flowModal.actionIntent": "Disparar intent",
  "flowModal.basicTab": "Básico",
  "flowModal.stepsTab": "Pasos",
  "flowModal.completeTab": "Al Completar",
  "flowModal.keyLabel": "Key (identificador) *",
  "flowModal.nameRequired": "Nombre *",
  "flowModal.description": "Descripción",
  "flowModal.descriptionPlaceholder": "Descripción del flujo",
  "flowModal.triggerIntentLabel": "Intent que dispara este flow",
  "flowModal.noTrigger": "Ninguno (manual)",
  "flowModal.triggerNote": "Solo se muestran intents con handlerType=\"flow\"",
  "flowModal.timeout": "Timeout (minutos)",
  "flowModal.flowActive": "Flow activo",
  "flowModal.noStepsDefined": "No hay pasos definidos",
  "flowModal.addFirstStep": "Agregar primer paso",
  "flowModal.stepNoMessage": "Paso sin mensaje",
  "flowModal.botMessage": "Mensaje del bot *",
  "flowModal.saveResponseAs": "Guardar respuesta como",
  "flowModal.responseType": "Tipo de respuesta",
  "flowModal.options": "Opciones",
  "flowModal.optionLabel": "Etiqueta",
  "flowModal.optionValue": "Valor",
  "flowModal.addOption": "+ Agregar opción",
  "flowModal.nextStep": "Siguiente paso",
  "flowModal.completeFlow": "Completar flow",
  "flowModal.nextInOrder": "Siguiente en orden",
  "flowModal.stepPrefix": "Paso",
  "flowModal.addStepButton": "+ Agregar paso",
  "flowModal.completeAction": "Acción al completar",
  "flowModal.finalMessage": "Mensaje final",
  "flowModal.handoffReason": "Razón del handoff",
  "flowModal.handoffVariables": "Variables a incluir en el handoff",
  "flowModal.nextFlowLabel": "Siguiente flow",
  "flowModal.triggerIntentSelect": "Intent a disparar",
  "flowModal.selectIntent": "Seleccionar intent",
  "flowModal.saveChanges": "Guardar Cambios",
  "flowModal.createFlow": "Crear Flow",
  "flowModal.errorKeyName": "Por favor completa la key y el nombre",
  "flowModal.errorNoSteps": "El flow debe tener al menos un paso",

  // ── Flows View (extended) ──────────────────────────────
  "flows.subtitle": "Define flujos de conversación paso a paso para recopilar información",
  "flows.searchPlaceholderFull": "Buscar por nombre, key o intent...",
  "flows.filterAll": "Todos",
  "flows.filterActive": "Activos",
  "flows.filterInactive": "Inactivos",
  "flows.loading": "Cargando flows...",
  "flows.noMatchingFlows": "No hay flows que coincidan con tu búsqueda",
  "flows.createFirstFlow": "Crear primer flow",
  "flows.inactive": "Inactivo",
  "flows.triggerLabel": "Trigger:",
  "flows.stepsLabel": "Pasos:",
  "flows.noSteps": "Sin pasos",
  "flows.onComplete": "Al completar:",
  "flows.onCompleteHandoff": "Handoff",
  "flows.onCompleteFlow": "Otro flow",
  "flows.onCompleteIntent": "Intent",
  "flows.onCompleteMessage": "Mensaje",
  "flows.started": "iniciados",
  "flows.completed": "completados",
  "flows.flowUpdated": "Flow actualizado",
  "flows.flowCreated": "Flow creado",
  "flows.errorSave": "Error al guardar",
  "flows.errorSaveFlow": "Error al guardar flow",
  "flows.confirmDelete": "¿Eliminar el flow \"{{name}}\"?",
  "flows.flowDeleted": "Flow eliminado",
  "flows.errorDelete": "Error al eliminar",
  "flows.errorDeleteFlow": "Error al eliminar flow",
  "flows.errorLoad": "Error al cargar flows",

  // ── Role Modal (extended) ──────────────────────────────
  "roleModal.nameIdentifier": "Nombre (identificador) *",
  "roleModal.nameHelp": "Solo letras minúsculas y guiones bajos",
  "roleModal.labelDisplay": "Etiqueta (visualización) *",
  "roleModal.description": "Descripción",
  "roleModal.allowsProfiles": "Permite perfiles",
  "roleModal.allowsProfilesHelp": "Los usuarios con este rol podrán tener perfiles específicos",
  "roleModal.roleActive": "Rol activo",
  "roleModal.roleActiveHelp": "Los roles inactivos no se pueden asignar a nuevos usuarios",
  "roleModal.systemRole": "Rol del Sistema",
  "roleModal.systemRoleHelp": "Este es un rol del sistema. El nombre no puede ser modificado.",
  "roleModal.saveChanges": "Guardar Cambios",
  "roleModal.createRole": "Crear Rol",
  "roleModal.errorNameLabel": "Por favor completa el nombre y la etiqueta",
  "roleModal.errorNameFormat": "El nombre solo puede contener letras minúsculas y guiones bajos",

  // ── Roles View (extended) ──────────────────────────────
  "roles.titleFull": "Gestión de Roles",
  "roles.subtitle": "Administra los roles del sistema y sus permisos",
  "roles.loading": "Cargando roles...",
  "roles.emptyDescription": "Crea el primer rol del sistema",
  "roles.system": "Sistema",
  "roles.permissionsLabel": "Permisos:",
  "roles.allPermissions": "Todos (*)",
  "roles.noPermissions": "Sin permisos",
  "roles.allowsProfilesLabel": "Permite perfiles:",
  "roles.createdByLabel": "Creado por:",
  "roles.updatedSuccess": "Rol actualizado correctamente",
  "roles.createdSuccess": "Rol creado correctamente",
  "roles.errorSave": "Error al guardar rol",
  "roles.confirmDelete": "¿Estás seguro de eliminar este rol?",
  "roles.deletedSuccess": "Rol eliminado correctamente",
  "roles.errorDelete": "Error al eliminar rol",
  "roles.errorLoad": "Error al cargar roles",

  // ── Campaign Products View (extended) ──────────────────
  "campaignProducts.subtitle": "Gestiona los productos asociados a cada campaña",
  "campaignProducts.newProduct": "Nuevo Producto de Campaña",
  "campaignProducts.listTitle": "Lista de Productos de Campaña",
  "campaignProducts.loading": "Cargando productos de campaña...",
  "campaignProducts.emptyDescription": "Comienza agregando tu primer producto de campaña",
  "campaignProducts.addProductButton": "Agregar Producto de Campaña",
  "campaignProducts.headerProduct": "Producto",
  "campaignProducts.headerCampaign": "Campaña",
  "campaignProducts.headerDetails": "Detalles",
  "campaignProducts.headerVariants": "Variantes",
  "campaignProducts.shade": "Sombra:",
  "campaignProducts.color": "Color:",
  "campaignProducts.variantCount": "variante(s)",

  // ── Master Catalog View (extended) ─────────────────────
  "masterCatalog.subtitle": "Gestiona la información base de productos (materiales, especificaciones, usos)",
  "masterCatalog.listTitle": "Entradas del Catálogo Maestro",
  "masterCatalog.loading": "Cargando catálogo...",
  "masterCatalog.emptyDescription": "Comienza agregando tu primera entrada al catálogo maestro",
  "masterCatalog.addEntryButton": "Agregar Entrada",
  "masterCatalog.headerName": "Nombre",
  "masterCatalog.headerDescription": "Descripción",
  "masterCatalog.headerComposition": "Composición",

  // ── Master Catalog Modal (extended) ────────────────────
  "masterCatalogModal.nameRequired": "Nombre *",
  "masterCatalogModal.description": "Descripción",
  "masterCatalogModal.descriptionPlaceholder": "Descripción de la subfamilia de productos...",
  "masterCatalogModal.composition": "Composición",
  "masterCatalogModal.update": "Actualizar",

  // ── Profile Modal (extended) ───────────────────────────
  "profileModal.roleRequired": "Rol *",
  "profileModal.selectRoleOption": "Seleccionar rol...",
  "profileModal.noRolesAvailable": "No hay roles disponibles que permitan perfiles. Crea o activa un rol primero.",
  "profileModal.nameIdentifier": "Nombre (identificador) *",
  "profileModal.nameHelp": "Solo letras minúsculas y guiones bajos",
  "profileModal.labelDisplay": "Etiqueta (visualización) *",
  "profileModal.description": "Descripción",
  "profileModal.descriptionPlaceholder": "Descripción breve del perfil y sus responsabilidades",
  "profileModal.profileActive": "Perfil activo",
  "profileModal.profileActiveHelp": "Los perfiles inactivos no se pueden asignar a nuevos usuarios",
  "profileModal.systemProfile": "Perfil del Sistema",
  "profileModal.systemProfileHelp": "Este es un perfil del sistema. El nombre y el rol no pueden ser modificados.",
  "profileModal.saveChanges": "Guardar Cambios",
  "profileModal.createProfile": "Crear Perfil",
  "profileModal.errorFields": "Por favor completa el nombre, la etiqueta y selecciona un rol",
  "profileModal.errorNameFormat": "El nombre solo puede contener letras minúsculas y guiones bajos",
  "profileModal.errorRoleNoProfiles": "El rol seleccionado no permite perfiles",
  "profileModal.landingPage": "Página de Inicio",
  "profileModal.landingPageDefault": "Por defecto (inicio /)",
  "profileModal.landingPageHelp": "Página que ven los usuarios con este perfil al iniciar sesión. Solo se muestran rutas a las que tienen permiso.",

  // ── Profiles View (extended) ───────────────────────────
  "profiles.titleFull": "Gestión de Perfiles",
  "profiles.subtitle": "Administra los perfiles dentro de cada rol",
  "profiles.loading": "Cargando perfiles...",
  "profiles.emptyDescription": "Crea el primer perfil del sistema",
  "profiles.noRole": "Sin Rol",
  "profiles.profileCount": "perfil",
  "profiles.profilesCount": "perfiles",
  "profiles.system": "Sistema",
  "profiles.permissionsLabel": "Permisos:",
  "profiles.allPermissions": "Todos (*)",
  "profiles.noPermissions": "Sin permisos",
  "profiles.createdByLabel": "Creado por:",
  "profiles.landingPage": "Landing:",
  "profiles.updatedSuccess": "Perfil actualizado correctamente",
  "profiles.createdSuccess": "Perfil creado correctamente",
  "profiles.errorSave": "Error al guardar perfil",
  "profiles.confirmDelete": "¿Estás seguro de eliminar este perfil?",
  "profiles.deletedSuccess": "Perfil eliminado correctamente",
  "profiles.errorDelete": "Error al eliminar perfil",
  "profiles.errorLoad": "Error al cargar perfiles",

  // ── Click Logs View (extended) ─────────────────────────
  "clickLogs.titleFull": "Registros de Clicks",
  "clickLogs.subtitle": "Analítica de enlaces compartidos con usuarios",
  "clickLogs.totalLinks": "Total Enlaces",
  "clickLogs.clicks": "Clicks",
  "clickLogs.ofLinks": "de enlaces",
  "clickLogs.ofClicks": "de clicks",
  "clickLogs.conversionsLabel": "Conversiones",
  "clickLogs.uniqueUsers": "Usuarios Únicos",
  "clickLogs.dailyChart": "Enlaces y Clicks por Día",
  "clickLogs.chartClicks": "Clicks",
  "clickLogs.chartLinks": "Enlaces",
  "clickLogs.filters": "Filtros",
  "clickLogs.startDate": "Fecha Inicio",
  "clickLogs.endDate": "Fecha Fin",
  "clickLogs.clickStatus": "Estado de Click",
  "clickLogs.conversionStatus": "Estado de Conversión",
  "clickLogs.filterAll": "Todos",
  "clickLogs.filterClicked": "Clickeado",
  "clickLogs.filterNotClicked": "No clickeado",
  "clickLogs.filterConverted": "Convertido",
  "clickLogs.filterNotConverted": "No convertido",
  "clickLogs.topProduct": "Producto más popular",
  "clickLogs.busiestDay": "Día más activo",
  "clickLogs.handovers": "Handovers",
  "clickLogs.handoversDescription": "Conversaciones transferidas",
  "clickLogs.topAd": "Anuncio top",
  "clickLogs.noAdName": "(sin nombre)",
  "clickLogs.noAdData": "Sin datos de anuncios",
  "clickLogs.noData": "Sin datos",
  "clickLogs.loading": "Cargando registros...",
  "clickLogs.noRecords": "No hay registros",
  "clickLogs.noRecordsDescription": "No se han generado enlaces rastreables aún",
  "clickLogs.headerPsid": "PSID",
  "clickLogs.headerLink": "Link",
  "clickLogs.headerProduct": "Producto",
  "clickLogs.headerCreated": "Creado",
  "clickLogs.headerClicked": "Clickeado",
  "clickLogs.headerStatus": "Estado",
  "clickLogs.statusClick": "Click",
  "clickLogs.statusPending": "Pendiente",
  "clickLogs.statusSale": "Venta",
  "clickLogs.statusSaleApprox": "Venta~",
  "clickLogs.errorLoadStats": "Error al cargar estadísticas",
  "clickLogs.errorLoadLogs": "Error al cargar registros de clicks",

  // ── Products View (extended) ─────────────────────────────
  "products.subtitle": "Gestiona el catálogo de productos",
  "products.listTitle": "Lista de Productos",
  "products.loadingProducts": "Cargando productos...",
  "products.startAdding": "Comienza agregando tu primer producto",
  "products.addProductButton": "Agregar Producto",
  "products.thName": "Nombre",
  "products.thType": "Tipo",
  "products.thSize": "Tamaño",
  "products.thPrice": "Precio",
  "products.thMLLink": "Link ML",
  "products.thActions": "Acciones",
  "products.view": "Ver",
  "products.editTooltip": "Editar",
  "products.deleteTooltip": "Eliminar",

  // ── Product Modal (extended) ─────────────────────────────
  "productModal.editTitle": "Editar Producto",
  "productModal.newTitle": "Nuevo Producto",
  "productModal.nameRequired": "Nombre *",
  "productModal.typeRequired": "Tipo *",
  "productModal.typeConfeccionada": "Confeccionada",
  "productModal.typeRollo": "Rollo",
  "productModal.size": "Tamaño",
  "productModal.price": "Precio",
  "productModal.wholesaleEnabled": "Mayoreo habilitado",
  "productModal.wholesaleMinQty": "Cantidad mínima",
  "productModal.wholesalePrice": "Precio mayoreo",
  "productModal.mlLink": "Link de Mercado Libre",
  "productModal.imageUrl": "URL de Imagen",
  "productModal.description": "Descripción",
  "productModal.descriptionPlaceholder": "Descripción del producto...",
  "productModal.cancel": "Cancelar",
  "productModal.updateProduct": "Actualizar Producto",
  "productModal.createProduct": "Crear Producto",

  // ── Product Family Tree View (extended) ──────────────────
  "familyTree.collapse": "Contraer",
  "familyTree.expand": "Expandir",
  "familyTree.sellable": "Vendible",
  "familyTree.noLink": "Sin Link",
  "familyTree.noDimensions": "Sin Dimensiones",
  "familyTree.inventory": "Inventario:",
  "familyTree.addChild": "Agregar Hijo",
  "familyTree.noChildrenSellable": "Los productos vendibles no pueden tener hijos",
  "familyTree.copySibling": "Copiar como Hermano",
  "familyTree.noImportSellable": "Los productos vendibles no pueden importar hijos",
  "familyTree.importProducts": "Importar Productos",
  "familyTree.viewDetails": "Ver Detalles",
  "familyTree.edit": "Editar",
  "familyTree.delete": "Eliminar",
  "familyTree.title": "Familias de Productos",
  "familyTree.subtitle": "Gestiona árboles de familias de productos con relaciones padre-hijo generacionales",
  "familyTree.newFamily": "Nueva Familia de Productos",
  "familyTree.globalCatalog": "Catálogo Global",
  "familyTree.globalCatalogDesc": "Se usa cuando no hay catálogo en el anuncio, campaña o familia de producto",
  "familyTree.treeTitle": "Árbol de Familias de Productos",
  "familyTree.treeSubtitle": "Vista de árbol expandible mostrando generaciones de productos. Solo los productos vendibles pueden ofrecerse en campañas.",
  "familyTree.loadingFamilies": "Cargando familias de productos...",
  "familyTree.noFamilies": "No se encontraron familias de productos",
  "familyTree.startAdding": "Comienza agregando tu primera familia de productos",
  "familyTree.addFamily": "Agregar Familia de Productos",
  "familyTree.viewDetailsTooltip": "Ver detalles",

  // ── Product Family Modal (extended) ──────────────────────
  "familyModal.editTitle": "Editar Familia de Productos",
  "familyModal.newTitle": "Nueva Familia de Productos",
  "familyModal.nameRequired": "Nombre *",
  "familyModal.specifications": "Especificaciones",
  "familyModal.specificationsPlaceholder": "Especificaciones técnicas del producto (medidas, materiales, características, etc.)...",
  "familyModal.marketingDescription": "Descripción de Marketing",
  "familyModal.marketingHint": "Contenido promocional que se utilizará en campañas de marketing",
  "familyModal.parentProduct": "Producto Padre",
  "familyModal.noParent": "Ninguno (Producto Raíz)",
  "familyModal.parentHint": "Selecciona un padre para crear un producto hijo en el árbol familiar",
  "familyModal.enabledDimensions": "Dimensiones Habilitadas",
  "familyModal.dimensionsHint": "Selecciona las dimensiones que se usarán para este producto. Los productos hijos heredarán todas las dimensiones.",
  "familyModal.dimensionsCount": "{{count}} dimensión(es) habilitada(s). Todos los productos hijos tendrán estas dimensiones.",
  "familyModal.dimensionValues": "Valores de Dimensiones",
  "familyModal.importDimensions": "Importar",
  "familyModal.dimensionValuesHint": "Estos valores son opcionales y se pueden heredar a productos hijos",
  "familyModal.sellableCheckbox": "Este producto es vendible (puede ofrecerse en campañas)",
  "familyModal.rootNotSellable": "Los productos raíz no pueden ser vendibles. Selecciona un producto padre primero.",
  "familyModal.price": "Precio",
  "familyModal.priceHint": "Los productos no vendibles pueden tener precio para aplicarlo a todos sus hijos",
  "familyModal.wholesaleEnabled": "Mayoreo habilitado",
  "familyModal.wholesaleHint": "Permite precio especial por cantidad",
  "familyModal.wholesaleMinQty": "Cantidad mínima",
  "familyModal.wholesaleMinHint": "Mínimo para precio de mayoreo",
  "familyModal.wholesalePrice": "Precio mayoreo",
  "familyModal.wholesalePriceHint": "Precio por unidad en mayoreo",
  "familyModal.catalogTitle": "Catálogo de Producto",
  "familyModal.catalogHint": "Este catálogo se usará como respaldo cuando el bot no encuentre catálogo en la campaña o anuncio.",
  "familyModal.sellableDetails": "Detalles del Producto Vendible",
  "familyModal.sku": "SKU",
  "familyModal.stock": "Inventario",
  "familyModal.sizeLabel": "Tamaño (Bot Query)",
  "familyModal.sizeAutoGenerated": "(Auto-generado)",
  "familyModal.sizeHint": "Se extrae automáticamente del nombre del producto. Puedes modificarlo manualmente si es necesario.",
  "familyModal.productDimensions": "Dimensiones del Producto",
  "familyModal.inherited": "(Heredadas)",
  "familyModal.dimensionsAutoHint": "Estas dimensiones se usan para auto-generar el campo \"Tamaño\" para consultas del bot",
  "familyModal.genericDescription": "Descripción Genérica (Cross-Selling)",
  "familyModal.genericDescHint": "Descripción breve que se mostrará cuando el cliente pregunte por este producto",
  "familyModal.requiresHumanAdvisor": "Requiere asesor humano",
  "familyModal.requiresHumanHint": "Cuando se marque, el bot ofrecerá conectar al cliente con un asesor humano al preguntar por este producto",
  "familyModal.thumbnail": "Miniatura (Thumbnail)",
  "familyModal.thumbnailHint": "URL de la imagen miniatura del producto",
  "familyModal.onlineStoreLinks": "Enlaces a Tiendas Online",
  "familyModal.selectStore": "-- Seleccionar tienda --",
  "familyModal.preferred": "Principal",
  "familyModal.addLink": "Agregar enlace",
  "familyModal.importFromProducts": "Importar de Productos",
  "familyModal.linksHint": "Agrega enlaces manualmente o importa el link de Mercado Libre desde los productos existentes",
  "familyModal.cancel": "Cancelar",
  "familyModal.updateFamily": "Actualizar Familia de Productos",
  "familyModal.createFamily": "Crear Familia de Productos",
  "familyModal.importMLLink": "Importar Link de Mercado Libre",
  "familyModal.searchingFor": "Buscando link para: ",
  "familyModal.productsAvailable": "{{count}} productos disponibles",
  "familyModal.productsFound": "{{count}} encontrados",
  "familyModal.searchPlaceholder": "Buscar por nombre, tamaño o descripción...",
  "familyModal.loadingProducts": "Cargando productos...",
  "familyModal.noProductsFound": "No se encontraron productos con ese criterio",
  "familyModal.noProductsAvailable": "No hay productos disponibles",
  "familyModal.withLink": "Con Link",
  "familyModal.noLinkLabel": "Sin Link",
  "familyModal.clearDimension": "Limpiar valor de dimensión",
  "familyModal.openLink": "Abrir enlace en nueva pestaña",
  "familyModal.noInheritedDimensions": "No hay dimensiones heredadas para importar",

  // ── Product Details Modal (extended) ─────────────────────
  "productDetails.name": "Nombre",
  "productDetails.generation": "Generación",
  "productDetails.status": "Estado",
  "productDetails.sellable": "Vendible",
  "productDetails.notSellable": "No Vendible",
  "productDetails.parentProduct": "Producto Padre",
  "productDetails.price": "Precio",
  "productDetails.priceInherited": "(heredado)",
  "productDetails.priceApply": "Este precio se puede aplicar a todos los productos vendibles descendientes",
  "productDetails.priceInheritedHint": "Este precio se hereda de un producto padre en la jerarquía",
  "productDetails.salesInfo": "Información de Venta",
  "productDetails.sku": "SKU",
  "productDetails.inventory": "Inventario",
  "productDetails.units": "unidades",
  "productDetails.availability": "Disponibilidad",
  "productDetails.available": "Disponible",
  "productDetails.notAvailable": "No Disponible",
  "productDetails.active": "Activo",
  "productDetails.inactive": "Inactivo",
  "productDetails.requiresHumanAdvisor": "Requiere asesor humano",
  "productDetails.specifications": "Especificaciones",
  "productDetails.marketingDescription": "Descripción de Marketing",
  "productDetails.genericDescription": "Descripción Genérica (Cross-Selling)",
  "productDetails.onlineStoreLinks": "Enlaces a Tiendas Online",
  "productDetails.onlineStore": "Tienda Online",
  "productDetails.image": "Imagen",
  "productDetails.imageUnavailable": "Imagen no disponible",
  "productDetails.dimensionsAvailable": "Dimensiones Disponibles",
  "productDetails.dimensionValues": "Valores de Dimensiones",
  "productDetails.ownDimensions": "Las propias están en morado, las heredadas en ámbar",
  "productDetails.allInherited": "Todas estas dimensiones se heredan de productos padres",
  "productDetails.childrenCount": "Este producto tiene {{count}} hijo",
  "productDetails.childrenCountPlural": "Este producto tiene {{count}} hijos",
  "productDetails.close": "Cerrar",
  "productDetails.inheritedLabel": "heredada",

  // ── Product Tree Selector (extended) ─────────────────────
  "productTreeSelector.searchProducts": "Buscar productos...",
  "productTreeSelector.collapseAll": "Contraer todo",
  "productTreeSelector.expandAll": "Expandir todo",
  "productTreeSelector.loadingProducts": "Cargando productos...",
  "productTreeSelector.noProductsFound": "No se encontraron productos",
  "productTreeSelector.noProductsAvailable": "No hay productos disponibles",
  "productTreeSelector.inherited": "Heredado",
  "productTreeSelector.sellable": "Vendible",
  "productTreeSelector.notAvailable": "No disponible",
  "productTreeSelector.selectedSpecific": "{{count}} producto seleccionado (específico)",
  "productTreeSelector.selectedSpecificPlural": "{{count}} productos seleccionados (específicos)",
  "productTreeSelector.inheritedProducts": "{{count}} producto heredado",
  "productTreeSelector.inheritedProductsPlural": "{{count}} productos heredados",
  "productTreeSelector.from": "de",
  "productTreeSelector.noSelection": "Sin productos seleccionados",
  "productTreeSelector.overriding": "(Sobrescribiendo {{count}} producto heredado de {{from}})",
  "productTreeSelector.overridingPlural": "(Sobrescribiendo {{count}} productos heredados de {{from}})",

  // ── Copy Product Modal (extended) ────────────────────────
  "copyProduct.selectChildrenDesc": "Selecciona qué hijos deseas copiar junto con \"{{name}}\"",
  "copyProduct.selectParent": "Selecciona el Padre del Producto Copiado",
  "copyProduct.loadingFamilies": "Cargando familias...",
  "copyProduct.noFamilies": "No hay familias disponibles",
  "copyProduct.parentHelp": "Click en una familia para seleccionarla como padre del producto copiado. Los productos vendibles no pueden tener hijos.",
  "copyProduct.noChildren": "Este producto no tiene hijos. Se copiará solo el producto.",
  "copyProduct.selectedCount": "{{selected}} de {{total}} seleccionados",
  "copyProduct.selectAllBtn": "Seleccionar Todos",
  "copyProduct.deselectAllBtn": "Deseleccionar Todos",
  "copyProduct.sellableLabel": "Vendible",
  "copyProduct.childrenCopied": "{{count}} hijo(s) - se copiarán también",
  "copyProduct.cancel": "Cancelar",
  "copyProduct.copyProduct": "Copiar Producto",
  "copyProduct.copyWithChildren": "Copiar con {{count}} hijo(s)",
  "copyProduct.copyOnly": "Copiar Solo Producto",
  "copyProduct.cannotHaveChildren": "(No puede tener hijos)",
  "copyProduct.selectParentAlert": "Por favor selecciona un padre para el producto copiado",
  "copyProduct.errorLoadFamilies": "Error al cargar familias disponibles",

  // ── Import Products Modal (extended) ─────────────────────
  "importProducts.titleFromProducts": "Importar Productos desde Productos",
  "importProducts.selectOrphan": "Selecciona productos huérfanos (sin familia asignada) para importar a \"{{name}}\"",
  "importProducts.loadingProducts": "Cargando productos...",
  "importProducts.noProducts": "No hay productos disponibles para importar",
  "importProducts.selectAll": "Seleccionar todos",
  "importProducts.selectedCount": "{{selected}} de {{total}} seleccionados",
  "importProducts.priceLabel": "Precio:",
  "importProducts.selectedProducts": "{{count}} producto seleccionado",
  "importProducts.selectedProductsPlural": "{{count}} productos seleccionados",
  "importProducts.cancel": "Cancelar",
  "importProducts.importingBtn": "Importando...",
  "importProducts.importCount": "Importar {{count}} producto",
  "importProducts.importCountPlural": "Importar {{count}} productos",
  "importProducts.selectAtLeast": "Por favor selecciona al menos un producto",
  "importProducts.successCount": "{{count}} productos importados correctamente",
  "importProducts.errorImport": "Error al importar productos: ",
  "importProducts.errorLoad": "Error al cargar productos",

  // ── Usos y Grupos View (extended) ────────────────────────
  "usosGrupos.subtitle": "Gestiona usos y agrupaciones de productos para mejorar recomendaciones y organización",
  "usosGrupos.usosTabLabel": "Usos",
  "usosGrupos.gruposTabLabel": "Grupos",

  // ── Usos View (extended) ─────────────────────────────────
  "usos.subtitle": "Gestiona los diferentes usos y aplicaciones de productos",
  "usos.newUso": "Nuevo Uso",
  "usos.listTitle": "Lista de Usos",
  "usos.loadingUsos": "Cargando usos...",
  "usos.noUsosRegistered": "No hay usos registrados",
  "usos.startAdding": "Comienza agregando el primer uso",
  "usos.thName": "Nombre",
  "usos.thDescription": "Descripción",
  "usos.thActions": "Acciones",
  "usos.inactiveLabel": "Inactivo",
  "usos.productsCount": "{{count}} producto",
  "usos.productsCountPlural": "{{count}} productos",
  "usos.notFound": "{{count}} producto no encontrado",
  "usos.notFoundPlural": "{{count}} productos no encontrados",
  "usos.more": "+{{count}} más",
  "usos.editTooltip": "Editar",
  "usos.deleteTooltip": "Eliminar",

  // ── Usos Modal (extended) ────────────────────────────────
  "usosModal.editTitle": "Editar Uso",
  "usosModal.newTitle": "Nuevo Uso",
  "usosModal.basicInfo": "Información Básica",
  "usosModal.nameRequired": "Nombre *",
  "usosModal.description": "Descripción",
  "usosModal.descriptionPlaceholder": "Descripción del uso o aplicación del producto...",
  "usosModal.keywords": "Palabras Clave",
  "usosModal.keywordsHint": "Separadas por coma. El bot detectará estas palabras para sugerir productos.",
  "usosModal.imageUrl": "URL de Imagen",
  "usosModal.priorityLabel": "Prioridad: {{value}}",
  "usosModal.priorityLow": "Baja (1)",
  "usosModal.priorityHigh": "Alta (10)",
  "usosModal.available": "Uso disponible",
  "usosModal.associatedProducts": "Productos Asociados",
  "usosModal.productsHint": "Selecciona los productos asociados con este uso. Puedes expandir las categorías para ver productos específicos.",
  "usosModal.cancel": "Cancelar",
  "usosModal.updateUso": "Actualizar Uso",
  "usosModal.createUso": "Crear Uso",

  // ── Grupos View (extended) ───────────────────────────────
  "grupos.subtitle": "Agrupa productos para recomendaciones cruzadas y ofertas complementarias",
  "grupos.newGrupo": "Nuevo Grupo",
  "grupos.loadingGrupos": "Cargando grupos...",
  "grupos.noGruposRegistered": "No hay grupos registrados",
  "grupos.startAdding": "Comienza agregando el primer grupo de productos",
  "grupos.typeBundle": "Paquete",
  "grupos.typeComplementary": "Complementario",
  "grupos.typeAlternative": "Alternativo",
  "grupos.typeSeasonal": "Estacional",
  "grupos.typeCustom": "Personalizado",
  "grupos.inactiveLabel": "Inactivo",
  "grupos.productsCount": "{{count}} productos",
  "grupos.priorityLabel": "Prioridad: {{value}}",
  "grupos.discountLabel": "{{value}}% descuento",
  "grupos.productsIncluded": "Productos incluidos:",
  "grupos.moreProducts": "+{{count}} más...",
  "grupos.editTooltip": "Editar",
  "grupos.deleteTooltip": "Eliminar",

  // ── Grupos Modal (extended) ──────────────────────────────
  "gruposModal.editTitle": "Editar Grupo",
  "gruposModal.newTitle": "Nuevo Grupo",
  "gruposModal.basicInfo": "Información Básica",
  "gruposModal.nameRequired": "Nombre *",
  "gruposModal.description": "Descripción",
  "gruposModal.descriptionPlaceholder": "Descripción del grupo de productos...",
  "posModal.descriptionPlaceholder": "Descripción breve del punto de venta",
  "gruposModal.groupType": "Tipo de Grupo *",
  "gruposModal.typeBundleDesc": "Productos que van bien juntos",
  "gruposModal.typeComplementaryDesc": "Productos que se complementan",
  "gruposModal.typeAlternativeDesc": "Alternativas para el mismo caso de uso",
  "gruposModal.typeSeasonalDesc": "Agrupaciones estacionales",
  "gruposModal.typeCustomDesc": "Agrupación personalizada",
  "gruposModal.imageUrl": "URL de Imagen",
  "gruposModal.priorityAndDiscounts": "Prioridad y Descuentos",
  "gruposModal.priorityLabel": "Prioridad: {{value}}",
  "gruposModal.priorityLow": "Baja (1)",
  "gruposModal.priorityHigh": "Alta (10)",
  "gruposModal.discount": "Descuento (%)",
  "gruposModal.discountHint": "Descuento al comprar productos del grupo",
  "gruposModal.available": "Grupo disponible",
  "gruposModal.tags": "Etiquetas",
  "gruposModal.addTagPlaceholder": "Agregar etiqueta...",
  "gruposModal.addTag": "Agregar",
  "gruposModal.groupProducts": "Productos del Grupo",
  "gruposModal.groupProductsHint": "Selecciona los productos que pertenecen a este grupo. Puedes expandir las categorías para ver productos específicos.",
  "gruposModal.suggestedProducts": "Productos Sugeridos (Opcional)",
  "gruposModal.suggestedProductsHint": "Productos recomendados cuando se muestra este grupo. Puedes expandir las categorías para ver productos específicos.",
  "gruposModal.cancel": "Cancelar",
  "gruposModal.updateGrupo": "Actualizar Grupo",
  "gruposModal.createGrupo": "Crear Grupo",

  // ── Users View (extended) ────────────────────────────────
  "users.dashboardTitle": "Usuarios del Dashboard",
  "users.newUser": "Nuevo Usuario",
  "users.loadingUsers": "Cargando usuarios...",
  "users.noUsersDesc": "Crea el primer usuario del sistema",
  "users.thUser": "Usuario",
  "users.thRole": "Rol",
  "users.thProfile": "Perfil",
  "users.thStatus": "Estado",
  "users.thLastAccess": "Último acceso",
  "users.thActions": "Acciones",
  "users.activeStatus": "Activo",
  "users.inactiveStatus": "Inactivo",
  "users.never": "Nunca",
  "users.noPermissions": "Sin permisos",
  "users.editTooltip": "Editar",
  "users.deleteTooltip": "Eliminar",
  "users.confirmDelete": "¿Estás seguro de eliminar este usuario?",
  "users.updatedSuccess": "Usuario actualizado correctamente",
  "users.createdSuccess": "Usuario creado correctamente",
  "users.errorSave": "Error al guardar usuario",
  "users.deletedSuccess": "Usuario eliminado correctamente",
  "users.errorDelete": "Error al eliminar usuario",
  "users.errorLoad": "Error al cargar usuarios",

  // ── User Modal (extended) ────────────────────────────────
  "userModal.editTitle": "Editar Usuario",
  "userModal.newTitle": "Nuevo Usuario",
  "userModal.firstNameRequired": "Nombre *",
  "userModal.lastNameRequired": "Apellido *",
  "userModal.usernameRequired": "Usuario *",
  "userModal.usernameCannotChange": "El nombre de usuario no se puede cambiar",
  "userModal.emailRequired": "Email *",
  "userModal.passwordLabel": "Contraseña",
  "userModal.passwordEditHint": "Dejar en blanco para mantener la contraseña actual",
  "userModal.passwordPlaceholderEdit": "Dejar en blanco para no cambiar",
  "userModal.roleRequired": "Rol *",
  "userModal.loadingRoles": "Cargando roles...",
  "userModal.profileRequired": "Perfil *",
  "userModal.activeCheckbox": "Usuario activo",
  "userModal.cancel": "Cancelar",
  "userModal.updateUser": "Actualizar Usuario",
  "userModal.createUser": "Crear Usuario",
  "userModal.alertRequired": "Por favor completa todos los campos requeridos",
  "userModal.alertPasswordRequired": "La contraseña es requerida para nuevos usuarios",
  "userModal.alertProfileRequired": "El perfil es requerido para este rol",

  // ── Punto de Venta Modal (extended) ──────────────────────
  "posModal.editTitle": "Editar Punto de Venta",
  "posModal.newTitle": "Nuevo Punto de Venta",
  "posModal.infoTitle": "Información del Punto de Venta",
  "posModal.nameRequired": "Nombre *",
  "posModal.baseUrl": "URL Base",
  "posModal.baseUrlHint": "URL base opcional que se usará por defecto (ej: https://mercadolibre.com.mx/)",
  "posModal.icon": "Icono / Emoji",
  "posModal.iconHint": "Emoji o URL de imagen que representa la tienda",
  "posModal.description": "Descripción",
  "posModal.activeCheckbox": "Activo (mostrar en dropdowns)",
  "posModal.cancel": "Cancelar",
  "posModal.saveChanges": "Guardar Cambios",
  "posModal.createPOS": "Crear Punto de Venta",

  // ── Purchase Intent Stats (extended) ─────────────────────
  "purchaseIntent.titleLabel": "Intención de Compra",
  "purchaseIntent.refresh": "Actualizar",
  "purchaseIntent.high": "Alta",
  "purchaseIntent.medium": "Media",
  "purchaseIntent.low": "Baja",
  "purchaseIntent.highDesc": "Listos para comprar",
  "purchaseIntent.mediumDesc": "Explorando opciones",
  "purchaseIntent.lowDesc": "Curiosos / Competencia",
  "purchaseIntent.totalWithScore": "Total con score: {{count}} conversaciones",
  "purchaseIntent.leadsLabel": "Leads {{label}} Intención",
  "purchaseIntent.loadingLeads": "Cargando...",
  "purchaseIntent.noConversations": "No hay conversaciones con esta intención",

  // ── Intent Category Modal (extended) ─────────────────────
  "intentCategoryModal.editTitle": "Editar Categoría",
  "intentCategoryModal.newTitle": "Nueva Categoría",
  "intentCategoryModal.keyRequired": "Key (identificador) *",
  "intentCategoryModal.nameRequired": "Nombre *",
  "intentCategoryModal.descriptionLabel": "Descripción",
  "intentCategoryModal.color": "Color",
  "intentCategoryModal.order": "Orden",
  "intentCategoryModal.orderHint": "Menor número = aparece primero",
  "intentCategoryModal.preview": "Vista previa:",
  "intentCategoryModal.cancel": "Cancelar",
  "intentCategoryModal.saveChanges": "Guardar Cambios",
  "intentCategoryModal.createCategory": "Crear Categoría",
  "intentCategoryModal.alertKeyName": "Por favor completa la key y el nombre",
  "intentCategoryModal.alertKeyFormat": "La key solo puede contener letras minúsculas, números y guiones bajos",
  "intentCategoryModal.colorGreen": "Verde",
  "intentCategoryModal.colorBlue": "Azul",
  "intentCategoryModal.colorPurple": "Morado",
  "intentCategoryModal.colorOrange": "Naranja",
  "intentCategoryModal.colorRed": "Rojo",
  "intentCategoryModal.colorGray": "Gris",
  "intentCategoryModal.colorPink": "Rosa",
  "intentCategoryModal.colorTeal": "Teal",

  // ── Simulation Mode Selector (extended) ──────────────────
  "simulationSelector.viewAs": "Ver como...",
  "simulationSelector.viewLabel": "Vista: {{label}}",
  "simulationSelector.dropdownTitle": "Simular Nivel de Acceso",
  "simulationSelector.dropdownDesc": "Ve el dashboard como lo vería otro usuario",
  "simulationSelector.loadingRoles": "Cargando roles...",
  "simulationSelector.exitSimulation": "Salir de simulación",
  "simulationSelector.allPermissions": "(Todos los permisos)",
  "simulationSelector.fullAccess": "Acceso completo",
  "simulationSelector.permissionsCount": "{{count}} permisos",
  "simulationSelector.activeLabel": "Activo",
  "simulationSelector.noRoles": "No hay roles disponibles",
  "simulationSelector.accessLevel": "Simular nivel de acceso",

  // ── Tracked Link Generator (extended) ────────────────────
  "trackedLink.generateTitle": "Generar Enlace Rastreable",
  "trackedLink.searchProduct": "Buscar producto...",
  "trackedLink.loadingProducts": "Cargando...",
  "trackedLink.noProducts": "No hay productos",
  "trackedLink.generating": "Generando...",
  "trackedLink.generateBtn": "Generar Enlace Rastreable",
  "trackedLink.copiedBtn": "Copiado!",
  "trackedLink.copyBtn": "Copiar",
  "trackedLink.pasteHint": "Pega este enlace en la conversacion con el cliente",
  "trackedLink.errorLoad": "Error al cargar productos",
  "trackedLink.errorGenerate": "Error al generar enlace",
  "trackedLink.modeProduct": "Elegir Producto",
  "trackedLink.modeCustom": "URL Personalizada",
  "trackedLink.customUrlPlaceholder": "https://articulo.mercadolibre.com.mx/...",
  "trackedLink.customNamePlaceholder": "Nombre del producto (opcional)",
  "trackedLink.customNameHint": "Opcional — ayuda a identificar este enlace en reportes",
  "trackedLink.customDefault": "Enlace personalizado",

  // ── API Health Alerts (extended) ─────────────────────────
  "apiHealth.error": "Error",
  "apiHealth.apiErrorDetected": "API error detected",
  "apiHealth.consecutiveErrors": "Errores consecutivos:",
  "apiHealth.errorsLast24h": "Errores en 24h:",
  "apiHealth.since": "Desde:",
  "apiHealth.hideAlert": "Ocultar alerta",

  // ── Campaign Item Details Modal (extended) ───────────────
  "campaignDetails.typeCampaign": "Campaña",
  "campaignDetails.typeAdSet": "Conjunto de Anuncios",
  "campaignDetails.typeAd": "Anuncio",
  "campaignDetails.typeItem": "Item",
  "campaignDetails.detailsOf": "Detalles de {{type}}",
  "campaignDetails.noName": "Sin nombre",
  "campaignDetails.basicInfo": "Información Básica",
  "campaignDetails.name": "Nombre",
  "campaignDetails.reference": "Referencia",
  "campaignDetails.status": "Estado",
  "campaignDetails.facebookId": "ID de Facebook",
  "campaignDetails.internalId": "ID Interno",
  "campaignDetails.objective": "Objetivo",
  "campaignDetails.description": "Descripción",
  "campaignDetails.budget": "Presupuesto",
  "campaignDetails.daily": "Diario",
  "campaignDetails.total": "Total",
  "campaignDetails.targeting": "Segmentación",
  "campaignDetails.locations": "Ubicaciones",
  "campaignDetails.age": "Edad",
  "campaignDetails.optimization": "Optimización",
  "campaignDetails.creative": "Creatividad",
  "campaignDetails.callToAction": "Call to Action",
  "campaignDetails.associatedProducts": "Productos Asociados",
  "campaignDetails.close": "Cerrar",

  // ── Campaign Product Modal (extended) ────────────────────
  "campaignProductModal.editTitle": "Editar Producto de Campaña",
  "campaignProductModal.newTitle": "Nuevo Producto de Campaña",
  "campaignProductModal.campaignRef": "Referencia de Campaña *",
  "campaignProductModal.selectCampaign": "Seleccionar campaña...",
  "campaignProductModal.cantChange": "No se puede cambiar después de crear",
  "campaignProductModal.productName": "Nombre del Producto *",
  "campaignProductModal.shortName": "Nombre Corto",
  "campaignProductModal.shade": "Sombra",
  "campaignProductModal.color": "Color",
  "campaignProductModal.features": "Características",
  "campaignProductModal.addFeature": "Agregar",
  "campaignProductModal.variants": "Variantes",
  "campaignProductModal.sizePlaceholder": "Tamaño (ej: 4x6m)",
  "campaignProductModal.pricePlaceholder": "Precio",
  "campaignProductModal.sourceLocal": "Local",
  "campaignProductModal.sourceML": "Mercado Libre",
  "campaignProductModal.linkPlaceholder": "Link de compra",
  "campaignProductModal.inStock": "En stock",
  "campaignProductModal.outOfStock": "Sin stock",
  "campaignProductModal.addVariant": "Agregar Variante",
  "campaignProductModal.fallbackMessage": "Mensaje Fallback",
  "campaignProductModal.suggestClosest": "Sugerir alternativas cercanas",
  "campaignProductModal.active": "Activo",
  "campaignProductModal.cancel": "Cancelar",
  "campaignProductModal.updateProduct": "Actualizar Producto",
  "campaignProductModal.createProduct": "Crear Producto",

  // ── Permission Sections (shared by RoleModal & ProfileModal) ──
  "permissions.allPermissions": "Todos los permisos (*)",
  "permissions.conversations": "Conversaciones",
  "permissions.campaigns": "Campañas",
  "permissions.adsets": "Conjuntos de Anuncios",
  "permissions.ads": "Anuncios",
  "permissions.products": "Productos",
  "permissions.analytics": "Analíticas",
  "permissions.families": "Familias",
  "permissions.masterCatalog": "Catálogo Maestro",
  "permissions.usos": "Usos",
  "permissions.inventario": "Inventario",
  "permissions.users": "Usuarios",

  // ── Flows View (edit/delete button titles) ─────────────────
  "flows.editButton": "Editar",
  "flows.deleteButton": "Eliminar",

  // ── Menu: Ventas Manuales ──
  "menu.manualSales": "Ventas Manuales",

  // ── Messages: Registrar Venta botón ──
  "messages.registerSale": "Registrar Venta",
  "messages.closeSale": "Cerrar Venta",

  // ── Manual Sale Form ──
  "manualSale.title": "Registrar Venta",
  "manualSale.product": "Producto",
  "manualSale.productPlaceholder": "Nombre del producto...",
  "manualSale.amount": "Monto de Venta",
  "manualSale.notes": "Notas (opcional)",
  "manualSale.notesPlaceholder": "Detalles adicionales de esta venta...",
  "manualSale.register": "Registrar Venta",
  "manualSale.registering": "Registrando...",
  "manualSale.success": "¡Venta registrada!",
  "manualSale.error": "Error al registrar venta",

  // ── Manual Sales View ──
  "manualSales.title": "Ventas Manuales",
  "manualSales.totalSales": "Total de Ventas",
  "manualSales.totalRevenue": "Ingresos Totales",
  "manualSales.thisMonth": "Este Mes",
  "manualSales.from": "Desde:",
  "manualSales.to": "Hasta:",
  "manualSales.clearFilter": "Limpiar",
  "manualSales.noSales": "No hay ventas manuales registradas",
  "manualSales.colDate": "Fecha",
  "manualSales.colCustomer": "Cliente",
  "manualSales.colProduct": "Producto",
  "manualSales.colAmount": "Monto",
  "manualSales.colCampaign": "Campaña",
  "manualSales.colNotes": "Notas",

  // ── Home / Executive Dashboard ─────────────────────────
  "home.pageTitle": "Panel Ejecutivo",
  "home.totalRevenue": "Ingresos Totales",
  "home.totalConversions": "Conversiones Totales",
  "home.activeConversations": "Conversaciones Activas",
  "home.conversionRate": "Tasa de Conversión",
  "home.revenueOverTime": "Datos por Día",
  "home.clicks": "Clics",
  "home.conversions": "Conversiones",
  "home.linksGenerated": "Links Generados",
  "home.topProducts": "Productos Top",
  "home.byRevenue": "por ingresos",
  "home.salesFunnel": "Embudo de Ventas",
  "home.funnelLinks": "Links",
  "home.funnelClicks": "Clics",
  "home.funnelConversions": "Conversiones",
  "home.funnelRevenue": "Ingresos",
  "home.geoDistribution": "Distribución Geográfica",
  "home.byConversations": "por conversaciones",
  "home.confidenceBreakdown": "Confianza de Atribución",
  "home.high": "Alta",
  "home.medium": "Media",
  "home.low": "Baja",
  "home.adPerformance": "Rendimiento de Anuncios",
  "home.adName": "Nombre del Anuncio",
  "home.adClicks": "Clics",
  "home.adConversions": "Conversiones",
  "home.convRate": "Tasa Conv",
  "home.last7d": "7d",
  "home.last15d": "15d",
  "home.last30d": "30d",
  "home.last90d": "90d",
  "home.noData": "No hay datos disponibles",
  "home.loadingDashboard": "Cargando panel...",
  "home.conversations": "conversaciones",
  "home.cities": "ciudades",
  "home.uniqueUsers": "Usuarios Únicos",
  "home.totalMessages": "Mensajes Totales",
  "home.botResponseRate": "Tasa de Respuesta",
  "home.unanswered": "Sin Respuesta",
  "home.topRegion": "Región Principal",
  "home.byClicks": "por clics",
  "home.clickRate": "Tasa de Clic",
  "home.aboveBenchmark": "Arriba del promedio",
  "home.atBenchmark": "En el promedio",
  "home.belowBenchmark": "Debajo del promedio",

  // ── Conversions (additional charts) ────────────────────
  "conversions.confidenceChart": "Confianza de Atribución",
  "conversions.topProductsChart": "Productos Top por Ingresos",

  // ── Tickets ─────────────────────────────────────────────
  "tickets.title": "Tickets",
  "tickets.new": "Nuevo ticket",
  "tickets.create": "Crear ticket",
  "tickets.titleField": "Título",
  "tickets.titlePlaceholder": "Describe brevemente el tema...",
  "tickets.descriptionPlaceholder": "Detalle del ticket...",
  "tickets.priority": "Prioridad",
  "tickets.assignedTo": "Asignado a",
  "tickets.assignTo": "Asignar a",
  "tickets.comments": "comentarios",
  "tickets.commentPlaceholder": "Escribe un comentario...",
  "tickets.send": "Enviar",
  "tickets.empty": "No hay tickets",
  "tickets.creatorHint": "Puedes editar el título y descripción de tus tickets.",

  // ── Notifications ───────────────────────────────────────
  "notifications.title": "Notificaciones",
  "notifications.new": "Nueva notificación",
  "notifications.titlePlaceholder": "Título de la notificación...",
  "notifications.message": "Mensaje",
  "notifications.messagePlaceholder": "Contenido de la notificación...",
  "notifications.global": "Global",
  "notifications.individual": "Individual",
  "notifications.targetUser": "Usuario destino",
  "notifications.selectUser": "Selecciona un usuario...",
  "notifications.send": "Enviar notificación",
  "notifications.markAllRead": "Marcar todo como leído",
  "notifications.empty": "No hay notificaciones",
  "notifications.sentTo": "Enviado a",

  // ── Cross-Selling ───────────────────────────────────────
  "crossSell.title": "Cross-Selling",
  "crossSell.description": "Configura reglas de venta cruzada para sugerir productos complementarios a tus clientes automáticamente durante la conversación o después de una compra.",
  "crossSell.comingSoon": "Próximamente",
};

export default es;
